(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dino-game"]) return;
  try {
    
const canvas = document.getElementById('game');
const ctx = canvas.getContext('2d');

const titleScreen = document.getElementById('titleScreen');
const gameOverScreen = document.getElementById('gameOverScreen');
const finalScoreEl = document.getElementById('finalScore');
const courseDailyEl = document.getElementById('courseDaily');
const bossModeEl = document.getElementById('bossMode');
const titleLogoEl = document.getElementById('titleLogo');
const titleWordmarkEl = document.getElementById('titleWordmark');
const titleBestEl = document.getElementById('titleBest');
const gameOverBestEl = document.getElementById('gameOverBest');

/* Logo slot: show the image only if a real URL was pasted in, otherwise fall
   back to the wordmark. Also falls back if the URL 404s. */
(function setupLogo() {
  if (!titleLogoEl) return;
  const url = titleLogoEl.getAttribute('src') || '';
  const useText = () => {
    titleLogoEl.classList.add('hidden');
    if (titleWordmarkEl) titleWordmarkEl.classList.remove('hidden');
  };
  const useLogo = () => {
    titleLogoEl.classList.remove('hidden');
    if (titleWordmarkEl) titleWordmarkEl.classList.add('hidden');
  };
  if (!url || url.indexOf('PASTE-YOUR') !== -1) {
    titleLogoEl.removeAttribute('src');   // don't fire a doomed request
    useText();
    return;
  }
  // Hide the wordmark up front so the two never flash together, and fall back
  // to it if the URL 404s. `complete` covers a cached image, whose load event
  // can fire before this handler is attached.
  useLogo();
  titleLogoEl.onerror = useText;
  titleLogoEl.onload = useLogo;
  if (titleLogoEl.complete && titleLogoEl.naturalWidth === 0) useText();
})();

/* Full instructions live behind "How to play" so the stage stays uncluttered */
(function setupHelp() {
  const panel = document.getElementById('helpPanel');
  const open = document.getElementById('helpToggle');
  const close = document.getElementById('helpClose');
  if (!panel || !open || !close) return;
  open.addEventListener('click', () => panel.classList.remove('hidden'));
  close.addEventListener('click', () => panel.classList.add('hidden'));
})();

/* ============================================================
   SPRITE SHEETS
   NOTE: Liquid does NOT render inside {% javascript %} blocks —
   they compile to a static JS asset. Sprite URLs therefore live
   in data attributes on the <canvas> tag above.
   ============================================================ */
const SPRITE_URL = canvas.dataset.sprite || "";
const OB_SPRITE_URL = canvas.dataset.obstacleSprite || "";
const INVIS_SPRITE_URL = canvas.dataset.invisSprite || "";
const FACING_RIGHT = true;

const SHEET = {
  idle:       { y: 0,    cw: 81,  ch: 112, n: 6 },
  run:        { y: 112,  cw: 94,  ch: 119, n: 6 },
  takeoff:    { y: 231,  cw: 93,  ch: 166, n: 6 },
  jetpack:    { y: 397,  cw: 131, ch: 161, n: 6 },
  landing:    { y: 558,  cw: 115, ch: 112, n: 5 },
  dodge:      { y: 670,  cw: 196, ch: 90,  n: 4 },
  collect:    { y: 760,  cw: 144, ch: 114, n: 4 },
  hit:        { y: 874,  cw: 138, ch: 124, n: 5 },
  doublejump: { y: 998,  cw: 150, ch: 147, n: 5 },
  dash:       { y: 1145, cw: 250, ch: 142, n: 3 }
};

/* Invisibility sheet (waltor_invis.png): the same ten animations, drawn as a
   transparent white outline, packed onto the EXACT cell geometry of
   waltor_sprites.png - same rows, same cells, same frame counts. It is a
   straight image swap, so it shares SHEET, SCALE, FEET_OFFSET and TRAIL_ANIMS
   and cannot drift out of sync with the normal sprite. */

const OB_SHEET = {
  pillar_black: { y: 0,   cw: 120, ch: 126, n: 12, idle: 5, base: 5 },
  pillar_red:   { y: 126, cw: 119, ch: 152, n: 12, idle: 5, base: 14 },
  square_black: { y: 278, cw: 89,  ch: 92,  n: 6 },
  square_red:   { y: 370, cw: 117, ch: 121, n: 7 }
};
const OB_FRAME_TICKS = 6;
const OB_BREAK_TICKS = 3;
const OB_BREAK_LINGER = 10;
const OB_GROUND_SINK = 3;
const PILLAR_BODY_H = 112;
const SQUARE_BODY_W = 81;

const FEET_OFFSET = {
  takeoff: 0.30, doublejump: 0.22, jetpack: 0.15,
  landing: 0.05, dash: 0.03, dodge: 0.02
};
const TRAIL_ANIMS = { dash: true, dodge: true };
const REVERSED = { run: true };

const NATIVE_BODY_H = 112;
const DRAW_BODY_H = 58;
const SCALE = DRAW_BODY_H / NATIVE_BODY_H;

const sprite = new Image();
let spriteReady = false;
sprite.onload = () => { spriteReady = true; };
sprite.onerror = () => {
  console.warn('[Waltor] Sprite sheet failed to load from:', SPRITE_URL);
};
if (SPRITE_URL && !SPRITE_URL.includes('PASTE-YOUR')) sprite.src = SPRITE_URL;

const invisSprite = new Image();
let invisReady = false;
invisSprite.onload = () => { invisReady = true; };
invisSprite.onerror = () => {
  console.warn('[Waltor] Invisibility sheet failed to load from:', INVIS_SPRITE_URL,
    '- check the data-invis-sprite attribute. Falling back to the normal sheet.');
};
if (INVIS_SPRITE_URL && !INVIS_SPRITE_URL.includes('PASTE-YOUR')) {
  invisSprite.src = INVIS_SPRITE_URL;
}

const obSprite = new Image();
let obSpriteReady = false;
obSprite.onload = () => { obSpriteReady = true; };
obSprite.onerror = () => {
  console.warn('[Waltor] Obstacle sheet failed to load from:', OB_SPRITE_URL);
};
if (OB_SPRITE_URL && !OB_SPRITE_URL.includes('PASTE-YOUR')) obSprite.src = OB_SPRITE_URL;

/* ---------------- Core state ---------------- */
const GROUND_Y = 260;
const DINO_W = 30;
const DINO_H = 40;
const SLIDE_H = 20;      // hitbox height while sliding
const HIT_PAD = 4;

let running = false;
let started = false;
let paused = false;
let pauseDrawn = false;   // the pause overlay paints once, then rAF idles
let canJump = true;
let globalTick = 0;

let dino = {
  x: 50, y: GROUND_Y - DINO_H, vy: 0,
  jumping: false, jumpsUsed: 0, usedDouble: false
};
let sliding = false, slideTimer = 0, slideCd = 0, downHeld = false;
function curH() { return sliding ? SLIDE_H : DINO_H; }

/* Dash: a real move now, not just an animation. Burst forward,
   invulnerable, and anything you hit gets demolished for points.
   One air-dash per jump; short cooldown on the ground. */
const DINO_X0 = 50;
const DASH_LEN = 16;
const DASH_CD = 75;
const DASH_PUSH = 5;
let dashTimer = 0, dashCd = 0, airDashUsed = false;
function dashing() { return dashTimer > 0; }

let obstacles = [];          // black pillars
let hotObstacles = [];       // red pillars (2 dmg)
let flyingObstacles = [];    // black squares
let hotFlyingObstacles = []; // red squares (2 dmg)
let barriers = [];           // overhead girders - slide under
let coins = [];
let pickups = [];            // { kind, x, y, width, height }
let debris = [];             // kaiju boss projectiles
let popups = [];

let score = 0;
let baseSpeed = 5;
let speed = baseSpeed;
let animationFrameId = null;

let doubleJumpCount = 1;
let health = 2;
let maxHealth = 3;
let shieldCharges = 0;
let shieldTimer = 0;
const SHIELD_DUR = 900;   // ~15s of protection, then it pops on its own
let invincible = false;
let invincibilityTimer = 0;

// timed effects (ticks remaining)
let timers = { invis: 0, magnet: 0, x2: 0, slowmo: 0, rampage: 0 };
function isInvisible() { return timers.invis > 0; }

// combo: coins, near-misses and slide-unders build a streak;
// taking real damage resets it (a shield block preserves it)
let streak = 0;
function comboMult() { return 1 + Math.min(streak, 20) * 0.1; }
function bonus(base) {
  return Math.floor(base * comboMult()) * (timers.x2 > 0 ? 2 : 1);
}

let shake = 0;
let banner = null; // { title, sub, t }
function setBanner(title, sub) { banner = { title: title, sub: sub || '', t: 0 }; }

function addPopup(x, y, text, small) {
  popups.push({ x: x, y: y, t: 0, text: text, small: !!small });
}

/* Two independent switches - course generation and kaiju fights - so four
   combinations, each with its OWN scoreboard. A survival run without bosses
   skips the 1500-point kill bonuses entirely; scoring it against a boss run
   would be meaningless. Daily bests are keyed by date, so they reset nightly. */
let dailyMode = true;
let bossesOn = true;

function hashDateSeed() {
  const d = new Date();
  return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
}
function modeName() {
  return (dailyMode ? 'DAILY CITY' : 'ENDLESS') + (bossesOn ? '' : ' - SURVIVAL');
}
function hsKey() {
  const base = dailyMode ? 'waltorDaily_' + hashDateSeed() : 'waltorHighScore';
  return bossesOn ? base : base + '_nokaiju';
}
let highScore = 0;
function loadHighScore() {
  highScore = Number(localStorage.getItem(hsKey())) || 0;
}
function syncMode() {
  dailyMode = !courseDailyEl || courseDailyEl.checked;
  bossesOn = !bossModeEl || bossModeEl.checked;
  loadHighScore();
  if (titleBestEl) {
    titleBestEl.textContent = highScore
      ? (dailyMode ? "Today's best" : 'Best') + ' in ' + modeName() + ': ' + highScore
      : modeName() + (dailyMode ? ' - no score yet today' : ' - no score yet');
  }
}

/* ---------------- Sound: tiny synthesized SFX, no files to host ----------------
   The AudioContext can only start on a user gesture (autoplay policy), so
   ensure/resume is called from Start, keydown and touchstart. Mute persists. */
let audioCtx = null, masterGain = null;
let muted = false;
try { muted = localStorage.getItem('waltorMuted') === '1'; } catch (e) {}

function ensureAudio() {
  if (audioCtx) return;
  const AC = (typeof window !== 'undefined') && (window.AudioContext || window.webkitAudioContext);
  if (!AC) return;
  audioCtx = new AC();
  masterGain = audioCtx.createGain();
  masterGain.gain.value = muted ? 0 : 0.5;
  masterGain.connect(audioCtx.destination);
}
function resumeAudio() {
  ensureAudio();
  if (audioCtx && audioCtx.state === 'suspended') audioCtx.resume();
}
function toggleMute() {
  muted = !muted;
  try { localStorage.setItem('waltorMuted', muted ? '1' : '0'); } catch (e) {}
  if (masterGain) masterGain.gain.value = muted ? 0 : 0.5;
  const b = document.getElementById('muteBtn');
  if (b) b.innerHTML = muted ? '&#128263;' : '&#128266;';
}

function tone(f0, f1, dur, type, vol, delay) {
  if (!audioCtx || muted) return;
  const t = audioCtx.currentTime + (delay || 0);
  const o = audioCtx.createOscillator();
  const g = audioCtx.createGain();
  o.type = type || 'square';
  o.frequency.setValueAtTime(Math.max(30, f0), t);
  if (f1 && f1 !== f0) o.frequency.exponentialRampToValueAtTime(Math.max(30, f1), t + dur);
  g.gain.setValueAtTime(vol, t);
  g.gain.exponentialRampToValueAtTime(0.001, t + dur);
  o.connect(g); g.connect(masterGain);
  o.start(t); o.stop(t + dur + 0.03);
}
function noiseBurst(dur, vol, cutoff, delay) {
  if (!audioCtx || muted) return;
  const t = audioCtx.currentTime + (delay || 0);
  const n = Math.floor(audioCtx.sampleRate * dur);
  const buf = audioCtx.createBuffer(1, n, audioCtx.sampleRate);
  const d = buf.getChannelData(0);
  for (let i = 0; i < n; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / n);
  const s = audioCtx.createBufferSource();
  s.buffer = buf;
  const f = audioCtx.createBiquadFilter();
  f.type = 'lowpass'; f.frequency.value = cutoff || 1200;
  const g = audioCtx.createGain();
  g.gain.setValueAtTime(vol, t);
  g.gain.exponentialRampToValueAtTime(0.001, t + dur);
  s.connect(f); f.connect(g); g.connect(masterGain);
  s.start(t);
}
function sfx(name) {
  if (!audioCtx || muted) return;
  switch (name) {
    case 'jump':    tone(280, 520, 0.10, 'square', 0.12); break;
    case 'jump2':   tone(420, 760, 0.10, 'square', 0.12); break;
    case 'slide':   noiseBurst(0.14, 0.10, 900); break;
    case 'dash':    tone(180, 900, 0.13, 'sawtooth', 0.10); break;
    case 'coin':    tone(920, 920, 0.05, 'sine', 0.12); tone(1380, 1380, 0.08, 'sine', 0.10, 0.05); break;
    case 'pickup':  tone(520, 520, 0.07, 'triangle', 0.14); tone(780, 780, 0.10, 'triangle', 0.12, 0.07); break;
    case 'rampage': tone(160, 640, 0.28, 'sawtooth', 0.16); noiseBurst(0.2, 0.08, 700, 0.05); break;
    case 'arp':     [660, 880, 1100].forEach((f, i) => tone(f, f, 0.08, 'triangle', 0.11, i * 0.06)); break;
    case 'tick':    tone(1500, 1500, 0.04, 'sine', 0.09); break;
    case 'hit':     noiseBurst(0.18, 0.20, 900); tone(130, 70, 0.22, 'square', 0.14); break;
    case 'block':   tone(720, 400, 0.14, 'triangle', 0.16); break;
    case 'crunch':  noiseBurst(0.16, 0.18, 650); tone(180, 90, 0.12, 'square', 0.08); break;
    case 'zip':     tone(300, 1400, 0.16, 'sawtooth', 0.12); break;
    case 'bossHit': noiseBurst(0.22, 0.2, 500); tone(90, 60, 0.3, 'sawtooth', 0.16); break;
    case 'roar':    tone(110, 55, 0.6, 'sawtooth', 0.18); tone(75, 50, 0.6, 'square', 0.10, 0.05); break;
    case 'fanfare': [520, 660, 780, 1040].forEach((f, i) => tone(f, f, 0.12, 'triangle', 0.13, i * 0.09)); break;
    case 'stage':   tone(620, 620, 0.10, 'sine', 0.10); tone(930, 930, 0.14, 'sine', 0.09, 0.09); break;
    case 'over':    [420, 320, 210].forEach((f, i) => tone(f, f * 0.92, 0.16, 'square', 0.12, i * 0.14)); break;
    case 'start':   tone(440, 660, 0.10, 'triangle', 0.10); break;
  }
}
(function initMuteBtn() {
  const b = document.getElementById('muteBtn');
  if (!b) return;
  b.innerHTML = muted ? '&#128263;' : '&#128266;';
  b.addEventListener('click', function () { resumeAudio(); toggleMute(); this.blur(); });
})();

/* ---------------- Seedable RNG (Daily City mode) ---------------- */
function mulberry32(a) {
  return function () {
    a |= 0; a = a + 0x6D2B79F5 | 0;
    let t = Math.imul(a ^ a >>> 15, 1 | a);
    t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
  };
}
let rng = Math.random; // pattern/spawn decisions route through this
let dailySeedLabel = '';

/* ---------------- Stages ---------------- */
const STAGE_LEN = 2000;   // score per stage
const STAGES = [
  { name: 'DOWNTOWN', sub: 'Morning rush', tile: 'day',
    skyTop: '#dff3ff', skyBot: '#f2fbff', scoreCol: '#000000',
    cloud: 0.9, star: 0, glow: 0, haze: 0, rain: 0,
    robot: '#a2bfd4', kaiju: '#96b6cb', rEye: '#eaf6ff', kEye: '#eaf6ff' },
  { name: 'NEON ROW', sub: 'The city sleeps. You do not.', tile: 'night',
    skyTop: '#0d1626', skyBot: '#28364f', scoreCol: '#eef3fa',
    cloud: 0.22, star: 1, glow: 1, haze: 0.16, rain: 0,
    robot: '#314052', kaiju: '#2a394b', rEye: '#a8d4ff', kEye: '#ffd28a' },
  { name: 'SUNRISE DOCKS', sub: 'You ran all night', tile: 'dawn',
    skyTop: '#ffc27a', skyBot: '#ffe8c9', scoreCol: '#3a2416',
    cloud: 0.75, star: 0, glow: 0, haze: 0, rain: 0,
    robot: '#a88ba4', kaiju: '#97798f', rEye: '#fff2d9', kEye: '#fff2d9' },
  { name: 'STORM CITY', sub: 'Weather warning in effect', tile: 'storm',
    skyTop: '#39424e', skyBot: '#5b6672', scoreCol: '#eef3fa',
    cloud: 0.5, star: 0, glow: 0.55, haze: 0.07, rain: 1,
    robot: '#4d5a66', kaiju: '#41505c', rEye: '#cfe6ff', kEye: '#ffe0a3' }
];
let stFrom = 0, stTo = 0, stT = 1;
function sNum(key) { return STAGES[stFrom][key] * (1 - stT) + STAGES[stTo][key] * stT; }
function sCol(key) { return lerpColor(STAGES[stFrom][key], STAGES[stTo][key], stT); }
function stageIdxFor(sc) { return Math.floor(sc / STAGE_LEN) % STAGES.length; }
function tierFor(sc) { return Math.min(5, Math.floor(sc / STAGE_LEN)); }

function lerpColor(a, b, t) {
  const pa = parseInt(a.slice(1), 16);
  const pb = parseInt(b.slice(1), 16);
  const ch = (sh) => {
    const va = (pa >> sh) & 255, vb = (pb >> sh) & 255;
    return Math.round(va + (vb - va) * t);
  };
  return 'rgb(' + ch(16) + ',' + ch(8) + ',' + ch(0) + ')';
}

// fixed starfield + rain field
const stars = [];
for (let i = 0; i < 42; i++) {
  stars.push({
    x: Math.random() * 800, y: 8 + Math.random() * 140,
    r: Math.random() < 0.2 ? 1.6 : 1, tw: Math.random() * Math.PI * 2
  });
}
const rain = [];
for (let i = 0; i < 70; i++) {
  rain.push({ x: Math.random() * 850, y: Math.random() * 300, l: 8 + Math.random() * 10, v: 7 + Math.random() * 4 });
}

/* ---------------- Waltor animation ---------------- */
const FRAME_TICKS = 6;
let animName = 'idle';
let animTick = 0;
let oneShot = null;

function setAnim(name) {
  if (animName !== name) { animName = name; animTick = 0; }
}
function playOneShot(name) { oneShot = { name: name, tick: 0 }; }

function grounded() {
  return !dino.jumping && dino.y + curH() >= GROUND_Y;
}

function pickAnim() {
  if (oneShot) return oneShot.name;
  if (dashing()) return 'dash';
  if (grounded()) {
    if (sliding) return 'dodge';
    if (timers.rampage > 0) return 'dash';
    return 'run';   // invisibility swaps the SHEET, not the animation
  }
  if (dino.vy < -1) return dino.usedDouble ? 'doublejump' : 'takeoff';
  if (dino.vy < 2.5) return 'jetpack';
  return 'landing';
}

function advanceAnim() {
  if (oneShot) {
    oneShot.tick++;
    const m = SHEET[oneShot.name];
    if (oneShot.tick >= m.n * FRAME_TICKS) oneShot = null;
  }
  setAnim(pickAnim());
  animTick++;
}

function drawWaltor() {
  const name = animName;
  // Invisible Waltor is the same sheet geometry, different pixels: every
  // frame sits in the identical cell, so the animation cannot desync.
  const ghost = isInvisible() && invisReady;
  const img = ghost ? invisSprite : sprite;
  const m = SHEET[name];

  const tick = oneShot ? oneShot.tick : animTick;
  let frame = Math.floor(tick / FRAME_TICKS) % m.n;
  if (REVERSED[name]) frame = m.n - 1 - frame;

  const dw = m.cw * SCALE;
  const dh = m.ch * SCALE;
  const feet = (FEET_OFFSET[name] || 0) * dh;

  const hitCX = dino.x + DINO_W / 2;
  const hitBottom = dino.y + curH();

  let dx;
  if (TRAIL_ANIMS[name]) {
    dx = FACING_RIGHT ? (dino.x + DINO_W + 10 - dw) : (dino.x - 10);
  } else {
    dx = hitCX - dw / 2;
  }
  const dy = hitBottom - dh + feet;

  // No opacity filter any more - invisibility gets its own sprite row.
  // Damage i-frames still blink so you can see the mercy window.
  let alpha = 1;
  if (invincible && Math.floor(invincibilityTimer / 5) % 2 === 0) alpha = 0.35;

  ctx.save();
  ctx.globalAlpha = alpha;
  if (!FACING_RIGHT) {
    ctx.translate(dx + dw / 2, 0);
    ctx.scale(-1, 1);
    ctx.translate(-(dx + dw / 2), 0);
  }
  if (spriteReady || ghost) {
    ctx.imageSmoothingEnabled = false;
    if (timers.rampage > 0) { // burning aura
      ctx.shadowColor = 'rgba(255,120,40,0.9)';
      ctx.shadowBlur = 16;
    } else if (ghost) {
      // faint violet rim so he's still findable against a bright sky.
      // delete these two lines for full "where did he go" mode.
      ctx.shadowColor = 'rgba(170,110,225,0.55)';
      ctx.shadowBlur = 9;
    } else if (dashing()) {
      ctx.shadowColor = 'rgba(120,200,255,0.9)';
      ctx.shadowBlur = 14;
      // speed streaks behind the lunge
      ctx.strokeStyle = 'rgba(180,225,255,0.55)';
      ctx.lineWidth = 2;
      ctx.beginPath();
      for (let i = 0; i < 4; i++) {
        const ly = dino.y + 6 + i * 9;
        ctx.moveTo(dino.x - 10 - i * 6, ly);
        ctx.lineTo(dino.x - 42 - i * 10, ly);
      }
      ctx.stroke();
    }
    ctx.drawImage(img, frame * m.cw, m.y, m.cw, m.ch, dx, dy, dw, dh);
  } else {
    ctx.fillStyle = 'black';
    ctx.fillRect(dino.x, dino.y, DINO_W, curH());
  }
  ctx.restore();

  // shield bubble - golden, and it flickers as the charge runs low
  if (shieldCharges > 0) {
    const bcx = dino.x + DINO_W / 2;
    const bcy = dino.y + curH() / 2 - 6;
    const r = 34 + Math.sin(globalTick * 0.1) * 2;
    const low = shieldTimer < 120;
    const flick = low ? (0.45 + 0.55 * Math.abs(Math.sin(globalTick * 0.25))) : 1;
    ctx.save();
    ctx.globalAlpha = flick;
    ctx.strokeStyle = 'rgba(255,210,62,0.85)';
    ctx.fillStyle = 'rgba(255,210,62,0.12)';
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.arc(bcx, bcy, r, 0, Math.PI * 2);
    ctx.fill();
    ctx.stroke();
    ctx.restore();
  }
}

/* ---------------- Background ---------------- */
let clouds = [];
function initClouds() {
  clouds = [];
  for (let i = 0; i < 4; i++) {
    clouds.push({
      x: Math.random() * 800, y: 30 + Math.random() * 90,
      s: 0.6 + Math.random() * 0.8, v: 0.25 + Math.random() * 0.25
    });
  }
}
initClouds();

/* ---------------- Parallax skylines (4 palettes, shared geometry) ---------------- */
const TILE_W = 1600;
let farX = 0, nearX = 0, roadX = 0;

// Bake the SAME random geometry into one tile per stage palette,
// so stage crossfades never morph the buildings.
function buildSkylineSet(g) {
  const H = g.maxH + 24;
  const keys = ['day', 'night', 'dawn', 'storm'];
  const tiles = {};
  const gcs = {};
  keys.forEach(k => {
    const c = document.createElement('canvas');
    c.width = TILE_W; c.height = H;
    tiles[k] = c; gcs[k] = c.getContext('2d');
  });
  const rect = (colKey, x, y, w, h) => {
    keys.forEach(k => {
      gcs[k].fillStyle = g.pal[k][colKey];
      gcs[k].fillRect(x, y, w, h);
    });
  };
  const winRect = (lit, x, y, w, h) => {
    keys.forEach(k => {
      gcs[k].fillStyle = lit ? g.pal[k].wLit : g.pal[k].wDark;
      gcs[k].fillRect(x, y, w, h);
    });
  };

  let x = 0;
  while (x < TILE_W) {
    const bw = g.minW + Math.random() * (g.maxW - g.minW);
    const bh = g.minH + Math.random() * (g.maxH - g.minH);
    const top = H - bh;
    rect('b', x, top, bw, bh);
    const r = Math.random();
    if (r < 0.3) {
      const ax = x + bw * (0.3 + Math.random() * 0.4);
      const ah = 8 + Math.random() * 14;
      rect('b', ax, top - ah, 2, ah);
    } else if (r < 0.5) {
      const boxW = 8 + Math.random() * 10;
      rect('b', x + bw * 0.2 + Math.random() * bw * 0.4, top - 6, boxW, 6);
    }
    for (let wy = top + 8; wy < H - 10; wy += g.pitchY) {
      for (let wx = x + 6; wx < x + bw - 8; wx += g.pitchX) {
        if (Math.random() < g.skip) continue;
        winRect(Math.random() < 0.55, wx, wy, g.winW, g.winH);
      }
    }
    x += bw + g.minGap + Math.random() * (g.maxGap - g.minGap);
  }
  return { tiles: tiles, height: H };
}

const farSkyline = buildSkylineSet({
  minW: 70, maxW: 130, minH: 100, maxH: 190,
  minGap: 0, maxGap: 8, pitchX: 12, pitchY: 14, winW: 5, winH: 7, skip: 0.35,
  pal: {
    day:   { b: '#ccdeea', wLit: '#bdd3e2', wDark: '#bdd3e2' },
    night: { b: '#26303f', wLit: '#8f7a45', wDark: '#2e3a4b' },
    dawn:  { b: '#b18cc4', wLit: '#eec9a2', wDark: '#a37fb5' },
    storm: { b: '#4a5560', wLit: '#8ea3b2', wDark: '#556370' }
  }
});
const nearSkyline = buildSkylineSet({
  minW: 40, maxW: 75, minH: 35, maxH: 85,
  minGap: 2, maxGap: 10, pitchX: 10, pitchY: 11, winW: 4, winH: 5, skip: 0.3,
  pal: {
    day:   { b: '#adc8da', wLit: '#9cb9cc', wDark: '#9cb9cc' },
    night: { b: '#161e2a', wLit: '#e0b355', wDark: '#1f2938' },
    dawn:  { b: '#7c5f92', wLit: '#ffd9a8', wDark: '#8a6da0' },
    storm: { b: '#333d47', wLit: '#9fb4c4', wDark: '#3e4b57' }
  }
});

function drawSkylineLayer(set, offset) {
  const y = GROUND_Y - set.height;
  const from = STAGES[stFrom].tile, to = STAGES[stTo].tile;
  ctx.drawImage(set.tiles[from], -offset, y);
  ctx.drawImage(set.tiles[from], -offset + TILE_W, y);
  if (stT > 0.01 && to !== from) {
    ctx.globalAlpha = stT;
    ctx.drawImage(set.tiles[to], -offset, y);
    ctx.drawImage(set.tiles[to], -offset + TILE_W, y);
    ctx.globalAlpha = 1;
  }
}

/* ---------------- Giant battle ---------------- */
let battleX = 950;
const BATTLE_SPAN = 230;

function easeInOut(u) {
  return u < 0.5 ? 2 * u * u : 1 - Math.pow(-2 * u + 2, 2) / 2;
}
function pulse(p, a, b) {
  if (p < a || p > b) return 0;
  const u = (p - a) / (b - a);
  return easeInOut(u < 0.5 ? u * 2 : (1 - u) * 2);
}

function drawGiantRobot(x, lean, punch, bob) {
  ctx.save();
  ctx.translate(x, GROUND_Y + bob);
  ctx.rotate(lean);
  ctx.fillStyle = sCol('robot');
  ctx.fillRect(-30, -62, 22, 62);
  ctx.fillRect(8, -62, 22, 62);
  ctx.fillRect(-36, -128, 72, 70);
  ctx.fillRect(-50, -122, 14, 44);
  ctx.fillRect(-44, -116, 12, 46);
  const reach = 26 + punch * 60;
  ctx.fillRect(26, -114, reach, 16);
  ctx.fillRect(26 + reach - 4, -120, 14, 26);
  ctx.fillRect(-32, -182, 62, 56);
  ctx.fillRect(-3, -200, 5, 18);
  ctx.beginPath();
  ctx.moveTo(-32, -182); ctx.lineTo(-42, -160); ctx.lineTo(-32, -150);
  ctx.fill();
  ctx.fillStyle = sCol('rEye');
  ctx.beginPath();
  ctx.moveTo(4, -166); ctx.lineTo(26, -157); ctx.lineTo(4, -150);
  ctx.fill();
  ctx.restore();
}

function drawKaiju(x, lean, jaw, bob, scale) {
  ctx.save();
  ctx.translate(x, GROUND_Y + bob);
  if (scale) ctx.scale(scale, scale);
  ctx.rotate(lean);
  ctx.fillStyle = sCol('kaiju');
  ctx.beginPath();
  ctx.moveTo(26, -80);
  ctx.quadraticCurveTo(95, -60, 130, -14);
  ctx.lineTo(102, -6);
  ctx.quadraticCurveTo(60, -40, 22, -52);
  ctx.closePath();
  ctx.fill();
  ctx.fillRect(-34, -58, 28, 58);
  ctx.fillRect(10, -58, 28, 58);
  ctx.fillRect(-52, -150, 92, 96);
  ctx.beginPath();
  ctx.moveTo(-30, -150); ctx.lineTo(-18, -172); ctx.lineTo(-6, -150);
  ctx.moveTo(0, -150);   ctx.lineTo(12, -168);  ctx.lineTo(24, -150);
  ctx.moveTo(28, -140);  ctx.lineTo(40, -156);  ctx.lineTo(48, -134);
  ctx.fill();
  ctx.fillRect(-56, -120, 14, 38);
  ctx.fillRect(-92, -172, 52, 46);
  ctx.fillRect(-124, -158, 34, 16);
  const drop = 3 + jaw * 12;
  ctx.beginPath();
  ctx.moveTo(-92, -138 + drop);
  ctx.lineTo(-120, -134 + drop);
  ctx.lineTo(-92, -126 + drop);
  ctx.closePath();
  ctx.fill();
  ctx.fillStyle = sCol('kEye');
  ctx.fillRect(-80, -160, 5, 5);
  ctx.restore();
}

function drawBattle() {
  if (boss.active) return; // he stepped forward - see drawBossKaiju
  const v = running ? effSpeed() * 0.2 : 0.25;
  battleX -= v;
  if (battleX < -600) battleX = 2200 + Math.random() * 1200;
  if (battleX > canvas.width + 700) return;

  const T = 280;
  const p = (globalTick % T) / T;
  const punch = pulse(p, 0.24, 0.42);
  const kRecoil = pulse(p, 0.30, 0.50);
  const lunge = pulse(p, 0.60, 0.80);
  const rRecoil = pulse(p, 0.65, 0.84);
  const bobR = Math.sin(globalTick * 0.04) * 2;
  const bobK = Math.sin(globalTick * 0.04 + 2) * 2;

  drawGiantRobot(battleX, -0.03 + punch * 0.16 - rRecoil * 0.1, punch, bobR);
  drawKaiju(battleX + BATTLE_SPAN, 0.03 - lunge * 0.18 + kRecoil * 0.12,
    Math.max(kRecoil, lunge), bobK);
}

function drawBackground() {
  const sky = ctx.createLinearGradient(0, 0, 0, GROUND_Y);
  sky.addColorStop(0, sCol('skyTop'));
  sky.addColorStop(1, sCol('skyBot'));
  ctx.fillStyle = sky;
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  const starA = sNum('star');
  if (starA > 0.01) {
    stars.forEach(s => {
      const tw = 0.55 + 0.45 * Math.sin(globalTick * 0.05 + s.tw);
      ctx.fillStyle = 'rgba(235,240,255,' + (starA * tw).toFixed(3) + ')';
      ctx.fillRect(s.x, s.y, s.r, s.r);
    });
    ctx.save();
    ctx.globalAlpha = starA;
    ctx.fillStyle = '#f2eedc';
    ctx.beginPath(); ctx.arc(420, 58, 19, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = '#dcd7c0';
    ctx.beginPath();
    ctx.arc(413, 52, 4, 0, Math.PI * 2);
    ctx.arc(426, 62, 3, 0, Math.PI * 2);
    ctx.arc(417, 66, 2, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  }

  ctx.fillStyle = 'rgba(255,255,255,' + sNum('cloud').toFixed(3) + ')';
  clouds.forEach(c => {
    c.x -= c.v * (running ? effSpeed() * 0.35 : 0.6);
    if (c.x < -80) { c.x = 850; c.y = 30 + Math.random() * 90; }
    ctx.beginPath();
    ctx.ellipse(c.x, c.y, 34 * c.s, 12 * c.s, 0, 0, Math.PI * 2);
    ctx.ellipse(c.x + 22 * c.s, c.y - 8 * c.s, 22 * c.s, 10 * c.s, 0, 0, Math.PI * 2);
    ctx.ellipse(c.x - 22 * c.s, c.y - 5 * c.s, 20 * c.s, 9 * c.s, 0, 0, Math.PI * 2);
    ctx.fill();
  });

  const farV = running ? effSpeed() * 0.08 : 0.15;
  const nearV = running ? effSpeed() * 0.45 : 0.35;
  farX = (farX + farV) % TILE_W;
  nearX = (nearX + nearV) % TILE_W;
  drawSkylineLayer(farSkyline, farX);
  drawBattle();
  drawSkylineLayer(nearSkyline, nearX);
  if (boss.active) drawBossKaiju();

  const hazeA = sNum('haze');
  if (hazeA > 0.005) {
    const haze = ctx.createLinearGradient(0, GROUND_Y - 70, 0, GROUND_Y);
    haze.addColorStop(0, 'rgba(232,182,90,0)');
    haze.addColorStop(1, 'rgba(232,182,90,' + hazeA.toFixed(3) + ')');
    ctx.fillStyle = haze;
    ctx.fillRect(0, GROUND_Y - 70, canvas.width, 70);
  }

  // rain (storm stage)
  const rainA = sNum('rain');
  if (rainA > 0.01) {
    ctx.strokeStyle = 'rgba(190,210,230,' + (0.45 * rainA).toFixed(3) + ')';
    ctx.lineWidth = 1;
    ctx.beginPath();
    rain.forEach(d => {
      d.y += d.v; d.x -= d.v * 0.35;
      if (d.y > 300) { d.y = -12; d.x = Math.random() * 900; }
      ctx.moveTo(d.x, d.y);
      ctx.lineTo(d.x - d.l * 0.35, d.y + d.l);
    });
    ctx.stroke();
  }

  // roadway
  ctx.fillStyle = '#26262b';
  ctx.fillRect(0, GROUND_Y, canvas.width, canvas.height - GROUND_Y);
  ctx.fillStyle = '#3d3d44';
  ctx.fillRect(0, GROUND_Y, canvas.width, 3);
  ctx.fillStyle = '#e8b62e';
  ctx.fillRect(0, GROUND_Y + 5, canvas.width, 2);
  roadX = (roadX + (running ? effSpeed() : 0)) % 62;
  ctx.fillStyle = '#e8b62e';
  for (let x = -roadX; x < canvas.width; x += 62) {
    ctx.fillRect(x, GROUND_Y + 22, 36, 4);
  }
}

/* ---------------- Combat / damage ---------------- */
function updateInvincibility() {
  if (invincible) {
    invincibilityTimer--;
    if (invincibilityTimer <= 0) invincible = false;
  }
}

function takeDamage(amount) {
  amount = amount || 1;
  if (invincible || isInvisible() || timers.rampage > 0) return;
  if (shieldCharges > 0) {           // shield eats the whole hit
    sfx('block');
    shieldCharges = 0;
    shieldTimer = 0;
    invincible = true;
    invincibilityTimer = 30;
    addPopup(dino.x + DINO_W / 2, dino.y - 12, 'BLOCKED');
    return;                           // streak survives a block
  }
  streak = 0;                         // real damage kills the combo
  health -= amount;
  if (health <= 0) {
    sfx('over');
    running = false;
    playOneShot('hit');
    setAnim('hit');
    finalScoreEl.textContent = score;
    const beat = score > highScore;
    if (beat) {
      highScore = score;
      localStorage.setItem(hsKey(), highScore);
    }
    if (gameOverBestEl) {
      gameOverBestEl.textContent = beat
        ? 'New best in ' + modeName() + '!'
        : modeName() + ' best: ' + highScore;
    }
    gameOverScreen.classList.remove('hidden');
  } else {
    sfx('hit');
    invincible = true;
    invincibilityTimer = 60;
    playOneShot('hit');
  }
}

function hitTest(bx, by, bw, bh) {
  const x = dino.x + HIT_PAD, y = dino.y + HIT_PAD;
  const w = DINO_W - HIT_PAD * 2, h = curH() - HIT_PAD * 2;
  return x < bx + bw && x + w > bx && y < by + bh && y + h > by;
}
function overlapX(bx, bw) {
  return dino.x < bx + bw && dino.x + DINO_W > bx;
}

function smash(ob) {
  if (!ob.breaking) { ob.breaking = true; ob.breakTick = 0; }
}

function rampageReward(x, y) {
  sfx('crunch');
  const g = bonus(50);
  score += g;
  streak++;
  addPopup(x, y - 10, '+' + g + ' SMASH!');
}

function nearMissAward(x, y, label) {
  sfx('tick');
  streak++;
  const g = bonus(15);
  score += g;
  addPopup(x, y, '+' + g + ' ' + label, true);
}

function checkCollisions() {
  /* Only RAMPAGE makes Waltor strong enough to break things. A plain dash is
     just speed - running full tilt into a girder is running into a girder.
     Dashing does still let him spike the kaiju's rocks: those are loose debris,
     not architecture.
     Invisibility means "nothing can touch YOU" - it never meant you can't
     touch the world, so a rampaging or rock-spiking ghost still connects. */
  const ramp = timers.rampage > 0;
  const canSpike = ramp || dashing();
  const phase = isInvisible() && !ramp;

  const pillarHit = (arr, dmg) => arr.forEach(ob => {
    if (ob.breaking) return;
    if (hitTest(ob.x, ob.y, 10, ob.height)) {
      if (ramp) { smash(ob); rampageReward(ob.x, ob.y); }
      else if (!phase) { takeDamage(dmg); smash(ob); }
    } else if (!ob.nearAwarded && dino.jumping && overlapX(ob.x, 10)) {
      // airborne pass directly above the pillar
      const clear = ob.y - (dino.y + curH());
      if (clear >= 0 && clear < 22) ob.near = true;
    }
    if (ob.near && !ob.nearAwarded && ob.x + 10 < dino.x - 6) {
      ob.nearAwarded = true;
      nearMissAward(dino.x + DINO_W, dino.y - 6, 'CLOSE!');
    }
  });
  pillarHit(hotObstacles, 2);
  pillarHit(obstacles, 1);

  const squareHit = (arr, dmg) => arr.forEach(fo => {
    if (fo.dead) return;
    if (hitTest(fo.x, fo.y, fo.width, fo.height)) {
      if (ramp) { fo.dead = true; rampageReward(fo.x, fo.y); }
      else if (!phase) { takeDamage(dmg); fo.dead = true; }
    } else if (!fo.nearAwarded && overlapX(fo.x, fo.width)) {
      const gapBelow = fo.y - (dino.y + curH());
      const gapAbove = dino.y - (fo.y + fo.height);
      const g = Math.max(gapBelow, gapAbove);
      if (g >= 0 && g < 14) fo.near = true;
    }
    if (fo.near && !fo.nearAwarded && fo.x + fo.width < dino.x - 6) {
      fo.nearAwarded = true;
      nearMissAward(dino.x + DINO_W, dino.y - 6, 'CLOSE!');
    }
  });
  squareHit(flyingObstacles, 1);
  squareHit(hotFlyingObstacles, 2);

  barriers.forEach(b => {
    if (b.dead) return;
    if (hitTest(b.x, b.y, b.width, b.height)) {
      if (ramp) { b.dead = true; rampageReward(b.x, b.y + b.height); }
      else if (!phase) { takeDamage(1); b.dead = true; }
    } else if (!b.nearAwarded && sliding && overlapX(b.x, b.width)) {
      b.near = true;
    }
    if (b.near && !b.nearAwarded && b.x + b.width < dino.x - 6) {
      b.nearAwarded = true;
      nearMissAward(dino.x + DINO_W, dino.y - 6, 'SLIDE!');
    }
  });

  // Rocks are ammunition. Dash (or rampage) into one and it rockets
  // back at the kaiju - that's how you actually kill the thing.
  debris.forEach(d => {
    if (d.dead || d.state === 'launch') return;
    const box = debrisBox(d);
    if (box && hitTest(box.x, box.y, box.w, box.h)) {
      if (canSpike) launchRock(d);
      else if (!phase && !isInvisible()) { takeDamage(1); d.dead = true; }
    }
  });

  hazards.forEach(hz => {
    if (hz.dead || hz.warn > 0 || phase) return;   // ghost slips the tail/plasma/wave
    const box = hazardBox(hz);
    if (hitTest(box.x, box.y, box.w, box.h)) takeDamage(hz.dmg || 1);
  });
}

/* ---------------- Input ---------------- */
function startSlide() {
  if (sliding || !grounded()) return;
  sliding = true;
  sfx('slide');
  slideTimer = 30;
  dino.y = GROUND_Y - SLIDE_H;
}
function endSlide() {
  if (!sliding) return;
  sliding = false;
  slideCd = 10;
  dino.y = GROUND_Y - DINO_H;
}
function startDash() {
  if (dashing()) return;
  if (grounded()) {
    if (dashCd > 0) return;
  } else {
    if (airDashUsed) return;
    airDashUsed = true;
    dino.vy = Math.min(dino.vy, 0.5); // brief hang time on an air dash
  }
  if (sliding) endSlide();
  dashTimer = DASH_LEN;
  dashCd = DASH_CD;
  sfx('dash');
  playOneShot('dash');
}

function doJump() {
  if (sliding) endSlide();
  if (canJump && grounded()) {
    sfx('jump');
    dino.vy = -12;
    dino.jumping = true;
    dino.usedDouble = false;
    canJump = false;
  } else if (doubleJumpCount > 0 && dino.jumpsUsed < doubleJumpCount && !grounded()) {
    sfx('jump2');
    dino.vy = -12;
    dino.jumpsUsed++;
    doubleJumpCount--;
    dino.usedDouble = true;
  }
}

function setPaused(v) {
  if (!running) return;
  if (v === paused) return;
  paused = v;
  pauseDrawn = false;
}

function drawPauseOverlay() {
  drawGame();   // repaint the frozen frame once, then dim it
  ctx.save();
  ctx.fillStyle = 'rgba(10,16,28,0.55)';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.textAlign = 'center';
  ctx.font = 'bold 30px Arial';
  ctx.fillStyle = '#fff';
  ctx.fillText('PAUSED', 400, 140);
  ctx.font = '14px Arial';
  ctx.fillStyle = 'rgba(255,255,255,0.85)';
  ctx.fillText('P / tap to resume', 400, 166);
  ctx.restore();
  ctx.textAlign = 'left';
}

window.addEventListener('keydown', e => {
  resumeAudio();
  if (e.code === 'KeyP') {
    e.preventDefault();
    setPaused(!paused);
    return;
  }
  if (e.code === 'KeyM') {
    toggleMute();
    return;
  }
  if (paused) {   // any action key resumes rather than acting
    if (e.code === 'Space' || e.code === 'ArrowUp' || e.code === 'KeyW' ||
        e.code === 'ArrowDown' || e.code === 'KeyS') {
      e.preventDefault();
      setPaused(false);
    }
    return;
  }
  if (e.code === 'Space' || e.code === 'ArrowUp' || e.code === 'KeyW') {
    e.preventDefault();
    if (!running) { if (started || e.code === 'Space') startGame(); }
    else doJump();
  }
  if (e.code === 'ShiftLeft' || e.code === 'ShiftRight' || e.code === 'KeyX' ||
      e.code === 'ArrowRight' || e.code === 'KeyD') {
    e.preventDefault();
    if (running && !paused) startDash();
  }
  if (e.code === 'ArrowDown' || e.code === 'KeyS') {
    e.preventDefault();
    downHeld = true;
    if (running) {
      if (grounded()) startSlide();
      else if (dino.vy < 11) dino.vy = 11; // fast-fall
    }
  }
});
window.addEventListener('keyup', e => {
  if (e.code === 'ArrowDown' || e.code === 'KeyS') downHeld = false;
});

/* ---------------- Touch: tap jump, swipe down slide, swipe right dash ----------------
   Gestures resolve on touchMOVE (not touchend) so a swipe fires the moment it
   crosses the threshold - at speed 13, waiting for the finger to lift is the
   difference between sliding under the girder and eating it. */
const IS_TOUCH = (typeof window !== 'undefined' && 'ontouchstart' in window) ||
  (typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0);
const SWIPE_DOWN_PX = 26;
const SWIPE_RIGHT_PX = 32;
const TAP_MS = 350;
let touchState = null;

function onTouchStart(e) {
  if (e.preventDefault) e.preventDefault();
  resumeAudio();
  const t = (e.changedTouches && e.changedTouches[0]) || e;
  touchState = { x: t.clientX, y: t.clientY, t0: Date.now(), used: false };
  if (paused) { setPaused(false); touchState.used = true; return; }
  if (!running && started) { startGame(); touchState.used = true; }
}
function onTouchMove(e) {
  if (!touchState || touchState.used) return;
  if (e.preventDefault) e.preventDefault();
  if (!running || paused) return;
  const t = (e.changedTouches && e.changedTouches[0]) || e;
  const dx = t.clientX - touchState.x;
  const dy = t.clientY - touchState.y;
  if (dy > SWIPE_DOWN_PX && Math.abs(dy) > Math.abs(dx)) {
    touchState.used = true;
    if (grounded()) startSlide();
    else if (dino.vy < 11) dino.vy = 11;   // fast-fall
  } else if (dx > SWIPE_RIGHT_PX && Math.abs(dx) > Math.abs(dy)) {
    touchState.used = true;
    startDash();
  }
}
function onTouchEnd(e) {
  if (e.preventDefault) e.preventDefault();
  if (touchState && !touchState.used && running && !paused &&
      Date.now() - touchState.t0 < TAP_MS) {
    doJump();
  }
  touchState = null;
}
if (canvas.addEventListener) {
  canvas.addEventListener('touchstart', onTouchStart, { passive: false });
  canvas.addEventListener('touchmove', onTouchMove, { passive: false });
  canvas.addEventListener('touchend', onTouchEnd, { passive: false });
}

/* Touch devices see touch instructions instead of key names */
(function touchifyUI() {
  if (!IS_TOUCH) return;
  const keyRow = document.getElementById('keyRow');
  if (keyRow) {
    keyRow.innerHTML =
      '<span><b>TAP</b>jump</span>' +
      '<span><b>SWIPE &darr;</b>slide</span>' +
      '<span><b>SWIPE &rarr;</b>dash</span>';
  }
  const help = document.getElementById('helpPanel');
  if (help) {
    const ps = help.getElementsByTagName('p');
    if (ps[0]) ps[0].innerHTML = '<b>TAP</b> jump &mdash; tap again in the air for a double jump';
    if (ps[1]) ps[1].innerHTML = '<b>SWIPE &darr;</b> slide under girders &mdash; and fast-fall in the air';
    if (ps[2]) ps[2].innerHTML = '<b>SWIPE &rarr;</b> dash &mdash; closes gaps, and spikes the kaiju\'s rocks back at it';
  }
  const hint = document.getElementById('retryHint');
  if (hint) hint.textContent = 'or tap the stage';
})();

/* Game-over overlay: tapping anywhere (not just the button) restarts */
gameOverScreen.addEventListener('click', function (e) {
  if (e && e.target && e.target.tagName === 'BUTTON') return; // button handles itself
  startGame();
});

/* ---------------- Game flow ---------------- */
let spawnDist = 160;   // px of world travel until the next chunk
const BOSS_HP = 6;
const BOSS_X = 640;
let boss = { active: false, t: 0, next: 5000, hp: BOSS_HP, flinch: 0, atk: 0, seq: 0 };
let telegraphs = [];
let hazards = [];      // tail sweeps, plasma bolts, shockwaves

function startGame() {
  running = true;
  started = true;
  paused = false;
  pauseDrawn = false;
  canJump = true;
  sliding = false; slideTimer = 0; slideCd = 0;
  dashTimer = 0; dashCd = 0; airDashUsed = false;
  slowF = 1;
  dino.x = DINO_X0;
  dino.y = GROUND_Y - DINO_H;
  dino.vy = 0;
  dino.jumping = false;
  dino.jumpsUsed = 0;
  dino.usedDouble = false;

  score = 0;
  speed = baseSpeed;
  health = 2;
  doubleJumpCount = 1;
  shieldCharges = 0;
  shieldTimer = 0;
  streak = 0;
  timers = { invis: 0, magnet: 0, x2: 0, slowmo: 0, rampage: 0 };
  invincible = false;
  invincibilityTimer = 0;
  oneShot = null;
  shake = 0;
  banner = null;

  stFrom = 0; stTo = 0; stT = 1;
  spawnDist = 160;
  pickupBag = [];
  boss = { active: false, t: 0, next: 5000, hp: BOSS_HP, flinch: 0, atk: 0, seq: 0 };
  telegraphs = [];
  hazards = [];   // (boss.next is overridden below when kaiju fights are off)

  obstacles = []; hotObstacles = [];
  flyingObstacles = []; hotFlyingObstacles = [];
  barriers = []; coins = []; pickups = []; debris = []; hazards = [];
  popups = [];

  syncMode();
  if (dailyMode) {
    const seed = hashDateSeed();
    rng = mulberry32(seed);
    dailySeedLabel = String(seed).replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
  } else {
    rng = Math.random;
    dailySeedLabel = '';
  }
  // bosses off -> the kaiju never steps onto the road
  if (!bossesOn) boss.next = Infinity;

  const sub = dailyMode ? dailySeedLabel + ' - same course for everyone'
                        : 'Randomly generated - no two runs alike';
  setBanner(modeName(), bossesOn ? sub : sub + ' - no kaiju, just the road');

  sfx('start');
  titleScreen.classList.add('hidden');
  gameOverScreen.classList.add('hidden');
}

if (typeof document.addEventListener === 'function') {
  document.addEventListener('visibilitychange', () => {
    if (document.hidden && running && !paused) setPaused(true);
  });
}
window.addEventListener('blur', () => {
  if (running && !paused) setPaused(true);
});

const pauseBtnEl = document.getElementById('pauseBtn');
if (pauseBtnEl) {
  pauseBtnEl.addEventListener('click', function () {
    resumeAudio();
    if (running) setPaused(!paused);
    this.blur();
  });
}

window.restartGame = function () { startGame(); };
[courseDailyEl, document.getElementById('courseEndless'), bossModeEl].forEach(el => {
  if (el) el.addEventListener('change', syncMode);
});
syncMode();   // paint the title-screen best for the default mode
document.getElementById('start').onclick = function () { resumeAudio(); startGame(); };

/* ---------------- HUD ---------------- */
function heartPath(cx, cy, s) {
  const bottom = cy + s * 0.95;
  const top = cy - s * 0.35;
  ctx.beginPath();
  ctx.moveTo(cx, bottom);
  ctx.bezierCurveTo(cx - s * 1.45, cy - s * 0.15, cx - s * 0.75, cy - s * 1.35, cx, top);
  ctx.bezierCurveTo(cx + s * 0.75, cy - s * 1.35, cx + s * 1.45, cy - s * 0.15, cx, bottom);
  ctx.closePath();
}

/* One shared badge renderer: pickups (r=11) and HUD chips (r=7) */
function drawBadge(kind, cx, cy, r) {
  const COLS = {
    doublejump: '#00aaff', invis: '#8e44ad', shield: '#ffd23e',
    magnet: '#e05555', x2: '#e6a817', slowmo: '#5dade2', rampage: '#ff6b35',
    dash: '#3d8fd1'
  };
  ctx.save();
  ctx.fillStyle = COLS[kind] || '#888';
  ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2); ctx.fill();
  ctx.strokeStyle = 'rgba(255,255,255,0.9)';
  ctx.lineWidth = Math.max(1, r * 0.12);
  ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2); ctx.stroke();

  const glyph = kind === 'shield' ? '#3a2d05' : '#fff';
  ctx.strokeStyle = glyph;
  ctx.fillStyle = glyph;
  ctx.lineWidth = Math.max(1.4, r * 0.18);
  ctx.lineCap = 'round';
  const u = r / 11; // icon unit scale
  ctx.beginPath();
  if (kind === 'doublejump') {
    ctx.moveTo(cx - 5 * u, cy + 4 * u); ctx.lineTo(cx, cy - 1 * u); ctx.lineTo(cx + 5 * u, cy + 4 * u);
    ctx.moveTo(cx - 5 * u, cy - 1 * u); ctx.lineTo(cx, cy - 6 * u); ctx.lineTo(cx + 5 * u, cy - 1 * u);
    ctx.stroke();
  } else if (kind === 'invis') {
    for (let i = -1; i <= 1; i++) {
      ctx.moveTo(cx - 5 * u, cy + i * 4 * u);
      ctx.lineTo(cx + (5 - Math.abs(i) * 2) * u, cy + i * 4 * u);
    }
    ctx.stroke();
  } else if (kind === 'shield') {
    ctx.moveTo(cx, cy - 6 * u);
    ctx.quadraticCurveTo(cx + 6 * u, cy - 4 * u, cx + 5 * u, cy);
    ctx.quadraticCurveTo(cx + 4 * u, cy + 5 * u, cx, cy + 7 * u);
    ctx.quadraticCurveTo(cx - 4 * u, cy + 5 * u, cx - 5 * u, cy);
    ctx.quadraticCurveTo(cx - 6 * u, cy - 4 * u, cx, cy - 6 * u);
    ctx.stroke();
  } else if (kind === 'magnet') {
    ctx.beginPath();
    ctx.arc(cx, cy - 1 * u, 4.5 * u, Math.PI, 0);
    ctx.moveTo(cx - 4.5 * u, cy - 1 * u); ctx.lineTo(cx - 4.5 * u, cy + 5 * u);
    ctx.moveTo(cx + 4.5 * u, cy - 1 * u); ctx.lineTo(cx + 4.5 * u, cy + 5 * u);
    ctx.stroke();
  } else if (kind === 'x2') {
    ctx.font = 'bold ' + Math.round(10 * u) + 'px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('x2', cx, cy + 0.5 * u);
  } else if (kind === 'slowmo') {
    ctx.beginPath(); ctx.arc(cx, cy, 5.5 * u, 0, Math.PI * 2); ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(cx, cy); ctx.lineTo(cx, cy - 4 * u);
    ctx.moveTo(cx, cy); ctx.lineTo(cx + 3 * u, cy + 1.5 * u);
    ctx.stroke();
  } else if (kind === 'dash') {
    ctx.moveTo(cx - 6 * u, cy - 4 * u); ctx.lineTo(cx + 1 * u, cy - 4 * u);
    ctx.moveTo(cx - 6 * u, cy); ctx.lineTo(cx + 3 * u, cy);
    ctx.moveTo(cx - 6 * u, cy + 4 * u); ctx.lineTo(cx + 1 * u, cy + 4 * u);
    ctx.moveTo(cx + 1 * u, cy - 5 * u); ctx.lineTo(cx + 6 * u, cy); ctx.lineTo(cx + 1 * u, cy + 5 * u);
    ctx.stroke();
  } else if (kind === 'rampage') {
    ctx.beginPath();
    ctx.moveTo(cx, cy + 6 * u);
    ctx.bezierCurveTo(cx - 7 * u, cy + 1 * u, cx - 2 * u, cy - 3 * u, cx - 1 * u, cy - 7 * u);
    ctx.bezierCurveTo(cx + 2 * u, cy - 4 * u, cx + 1 * u, cy - 3 * u, cx + 4 * u, cy - 5 * u);
    ctx.bezierCurveTo(cx + 7 * u, cy - 1 * u, cx + 5 * u, cy + 4 * u, cx, cy + 6 * u);
    ctx.fill();
  }
  ctx.restore();
  ctx.textAlign = 'left';
  ctx.textBaseline = 'alphabetic';
}

function drawHeartPickup(hp) {
  const t = hp.bobT || 0, ph = hp.ph || 0;
  const p = 0.5 + 0.5 * Math.sin(t * 0.12 + ph);
  const cx = hp.x + hp.width / 2;
  const cy = hp.y + hp.height / 2 + Math.sin(t * 0.06 + ph) * 1.5;
  const s = hp.width * 0.62 * (1 + 0.03 * p);
  ctx.save();
  ctx.shadowColor = 'rgba(255,90,120,' + (0.5 + 0.5 * p).toFixed(3) + ')';
  ctx.shadowBlur = 10 + 12 * p;
  const g = ctx.createLinearGradient(cx, cy - s, cx, cy + s);
  g.addColorStop(0, '#ff6b8a');
  g.addColorStop(1, '#d81e40');
  ctx.fillStyle = g;
  heartPath(cx, cy, s); ctx.fill();
  ctx.shadowBlur = 0;
  ctx.lineWidth = 1.5;
  ctx.strokeStyle = 'rgba(255,255,255,0.85)';
  heartPath(cx, cy, s); ctx.stroke();
  ctx.fillStyle = 'rgba(255,255,255,0.75)';
  ctx.beginPath();
  ctx.ellipse(cx - s * 0.4, cy - s * 0.36, s * 0.18, s * 0.12, -0.5, 0, Math.PI * 2);
  ctx.fill();
  ctx.restore();
}

function drawPickup(pu) {
  if (pu.kind === 'heart') { drawHeartPickup(pu); return; }
  const t = pu.bobT || 0, ph = pu.ph || 0;
  const p = 0.5 + 0.5 * Math.sin(t * 0.09 + ph);
  const cx = pu.x + pu.width / 2;
  // ~0.4 Hz float, constant at any game speed
  const cy = pu.y + pu.height / 2 + Math.sin(t * 0.045 + ph) * 3.2;
  ctx.save();
  ctx.shadowColor = 'rgba(255,255,255,' + (0.25 + 0.3 * p).toFixed(3) + ')';
  ctx.shadowBlur = 5 + 5 * p;
  drawBadge(pu.kind, cx, cy, 11);
  ctx.restore();
}

function drawCoin(c) {
  const t = c.bobT || 0, ph = c.ph || 0;
  const sq = Math.abs(Math.sin(t * 0.08 + ph)); // spin
  ctx.save();
  ctx.translate(c.x, c.y + Math.sin(t * 0.06 + ph) * 1.6);
  ctx.scale(0.35 + 0.65 * sq, 1);
  ctx.fillStyle = '#f4c430';
  ctx.beginPath(); ctx.arc(0, 0, c.r, 0, Math.PI * 2); ctx.fill();
  ctx.strokeStyle = '#b8860b';
  ctx.lineWidth = 1.6;
  ctx.beginPath(); ctx.arc(0, 0, c.r - 2.4, 0, Math.PI * 2); ctx.stroke();
  ctx.fillStyle = 'rgba(255,255,255,0.8)';
  ctx.beginPath(); ctx.arc(-c.r * 0.3, -c.r * 0.35, 1.7, 0, Math.PI * 2); ctx.fill();
  ctx.restore();
}

function drawHearts() {
  for (let i = 0; i < health; i++) {
    ctx.fillStyle = '#e22844';
    heartPath(30 + i * 30, 30, 11);
    ctx.fill();
  }
  for (let i = 0; i < doubleJumpCount; i++) {
    const x = 20 + health * 30 + i * 20;
    const y = 20;
    ctx.strokeStyle = '#00aaff';
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(x + 10, y + 22); ctx.lineTo(x + 10, y + 10); ctx.lineTo(x + 5, y + 15);
    ctx.moveTo(x + 10, y + 10); ctx.lineTo(x + 15, y + 15);
    ctx.stroke();
  }
}

// active timed effects: chip + draining bar, stacked under the hearts
function drawEffectsHUD() {
  const DUR = { invis: 300, magnet: 700, x2: 600, slowmo: 240, rampage: 300 };
  let y = 58;

  // dash readiness: a chip that fills back up after use
  const dashReady = dashCd <= 0;
  ctx.save();
  ctx.globalAlpha = dashReady ? 1 : 0.5;
  drawBadge('dash', 28, y, 7);
  ctx.restore();
  ctx.fillStyle = 'rgba(0,0,0,0.25)';
  ctx.fillRect(40, y - 3, 42, 6);
  ctx.fillStyle = dashReady ? '#7ec8ff' : '#4a6b85';
  ctx.fillRect(40, y - 3, 42 * (dashReady ? 1 : 1 - dashCd / DASH_CD), 6);
  y += 18;

  if (shieldCharges > 0) {
    drawBadge('shield', 28, y, 7);
    ctx.fillStyle = 'rgba(0,0,0,0.25)';
    ctx.fillRect(40, y - 3, 42, 6);
    ctx.fillStyle = '#ffd23e';
    ctx.fillRect(40, y - 3, 42 * (shieldTimer / SHIELD_DUR), 6);
    y += 18;
  }

  Object.keys(timers).forEach(k => {
    if (timers[k] <= 0) return;
    drawBadge(k, 28, y, 7);
    ctx.fillStyle = 'rgba(0,0,0,0.25)';
    ctx.fillRect(40, y - 3, 42, 6);
    ctx.fillStyle = '#fff';
    ctx.fillRect(40, y - 3, 42 * (timers[k] / DUR[k]), 6);
    y += 18;
  });
  if (streak > 0 && comboMult() > 1) {
    ctx.font = 'bold 15px Arial';
    ctx.fillStyle = '#e6a817';
    ctx.fillText('x' + comboMult().toFixed(1), 22, y + 8);
  }
}

function drawScore() {
  ctx.fillStyle = sCol('scoreCol');
  ctx.font = '20px Arial';
  const labelX = dailyMode ? 570 : 598;
  const numbersRightX = 782;
  ctx.textAlign = 'left';
  ctx.fillText('Score:', labelX, 30);
  ctx.textAlign = 'right';
  ctx.fillText(score.toString(), numbersRightX, 30);
  ctx.textAlign = 'left';
  ctx.fillText(dailyMode ? "Today's Best:" : 'High Score:', labelX, 55);
  // mode tag, small, under the scores
  ctx.font = '11px Arial';
  ctx.textAlign = 'right';
  ctx.globalAlpha = 0.65;
  ctx.fillText(modeName(), numbersRightX, 72);
  ctx.globalAlpha = 1;
  ctx.font = '20px Arial';
  ctx.textAlign = 'right';
  ctx.fillText(highScore.toString(), numbersRightX, 55);
  ctx.textAlign = 'left';
}

function drawBanner() {
  if (!banner) return;
  const LIFE = 170;
  const t = banner.t;
  let a = 1;
  if (t < 20) a = t / 20;
  else if (t > LIFE - 30) a = (LIFE - t) / 30;
  ctx.save();
  ctx.globalAlpha = Math.max(0, a);
  ctx.textAlign = 'center';
  ctx.font = 'bold 30px Arial';
  ctx.lineWidth = 5;
  ctx.strokeStyle = 'rgba(0,0,0,0.6)';
  ctx.strokeText(banner.title, 400, 118);
  ctx.fillStyle = '#ffd23e';
  ctx.fillText(banner.title, 400, 118);
  if (banner.sub) {
    ctx.font = '15px Arial';
    ctx.lineWidth = 3;
    ctx.strokeText(banner.sub, 400, 142);
    ctx.fillStyle = '#ffffff';
    ctx.fillText(banner.sub, 400, 142);
  }
  ctx.restore();
  ctx.textAlign = 'left';
  banner.t++;
  if (banner.t >= LIFE) banner = null;
}

/* ---------------- Obstacles ---------------- */
function drawGroundObstacleFallback(ob, hot) {
  const grad = ctx.createLinearGradient(ob.x, ob.y, ob.x + 10, ob.y);
  if (hot) {
    grad.addColorStop(0, '#e74c3c'); grad.addColorStop(1, '#96281b');
  } else {
    grad.addColorStop(0, '#3a3a3a'); grad.addColorStop(1, '#111');
  }
  ctx.fillStyle = grad;
  ctx.fillRect(ob.x, ob.y, 10, ob.height);
}

function drawFlyingObstacleFallback(fo, hot) {
  ctx.save();
  ctx.translate(fo.x + fo.width / 2, fo.y + fo.height / 2);
  ctx.rotate(Math.PI / 4);
  ctx.fillStyle = hot ? '#7a1408' : '#222';
  ctx.fillRect(-fo.width / 2, -fo.height / 2, fo.width, fo.height);
  ctx.fillStyle = '#c0392b';
  ctx.fillRect(-3, -3, 6, 6);
  ctx.restore();
}

function obstacleGlow(hot) {
  const g = sNum('glow');
  if (g <= 0.01) return 0;
  ctx.shadowColor = hot
    ? 'rgba(255,110,80,' + (0.9 * g).toFixed(3) + ')'
    : 'rgba(140,195,255,' + (0.85 * g).toFixed(3) + ')';
  return g;
}

function drawPillar(ob, hot) {
  if (!obSpriteReady) { drawGroundObstacleFallback(ob, hot); return; }
  const m = hot ? OB_SHEET.pillar_red : OB_SHEET.pillar_black;
  let frame;
  if (ob.breaking) {
    frame = Math.min(m.idle + Math.floor(ob.breakTick / OB_BREAK_TICKS), m.n - 1);
  } else {
    frame = Math.floor((globalTick + ob.phase) / OB_FRAME_TICKS) % m.idle;
  }
  const s = (ob.height * 1.35) / PILLAR_BODY_H;
  const dw = m.cw * s;
  const dh = m.ch * s;
  const dx = ob.x + 5 - dw / 2;
  const dy = GROUND_Y - dh + m.base * s + OB_GROUND_SINK;
  ctx.imageSmoothingEnabled = false;
  if (obstacleGlow(hot)) {
    ctx.save();
    ctx.shadowBlur = 12;
    ctx.drawImage(obSprite, frame * m.cw, m.y, m.cw, m.ch, dx, dy, dw, dh);
    ctx.drawImage(obSprite, frame * m.cw, m.y, m.cw, m.ch, dx, dy, dw, dh);
    ctx.restore();
  }
  ctx.drawImage(obSprite, frame * m.cw, m.y, m.cw, m.ch, dx, dy, dw, dh);
}

function drawSquare(fo, hot) {
  if (!obSpriteReady) { drawFlyingObstacleFallback(fo, hot); return; }
  const m = hot ? OB_SHEET.square_red : OB_SHEET.square_black;
  const frame = Math.floor((globalTick + fo.phase) / OB_FRAME_TICKS) % m.n;
  const s = (fo.width * 1.5) / SQUARE_BODY_W;
  const dw = m.cw * s;
  const dh = m.ch * s;
  const dx = fo.x + fo.width / 2 - dw / 2;
  const dy = fo.y + fo.height / 2 - dh / 2;
  ctx.imageSmoothingEnabled = false;
  if (obstacleGlow(hot)) {
    ctx.save();
    ctx.shadowBlur = 10;
    ctx.drawImage(obSprite, frame * m.cw, m.y, m.cw, m.ch, dx, dy, dw, dh);
    ctx.drawImage(obSprite, frame * m.cw, m.y, m.cw, m.ch, dx, dy, dw, dh);
    ctx.restore();
  }
  ctx.drawImage(obSprite, frame * m.cw, m.y, m.cw, m.ch, dx, dy, dw, dh);
}

// Overhead girder: hangs low over the lane. Can't be jumped - slide under.
function drawBarrier(b) {
  const bob = Math.sin(globalTick * 0.05 + b.phase) * 2;
  const x = b.x, y = b.y + bob, w = b.width, h = b.height;
  ctx.save();
  if (obstacleGlow(false)) {
    ctx.shadowBlur = 10;
  }
  // body
  ctx.fillStyle = '#2d2f36';
  ctx.fillRect(x, y, w, h - 12);
  ctx.shadowBlur = 0;
  // rivets
  ctx.fillStyle = '#484b55';
  for (let ry = y + 8; ry < y + h - 20; ry += 14) ctx.fillRect(x + w / 2 - 2, ry, 4, 4);
  // hazard stripes on the low edge
  ctx.fillStyle = '#e8b62e';
  ctx.fillRect(x - 3, y + h - 12, w + 6, 12);
  ctx.fillStyle = '#26262b';
  ctx.beginPath();
  for (let sx = 0; sx < w + 6; sx += 12) {
    ctx.moveTo(x - 3 + sx, y + h);
    ctx.lineTo(x - 3 + sx + 6, y + h - 12);
    ctx.lineTo(x - 3 + sx + 12, y + h - 12);
    ctx.lineTo(x - 3 + sx + 6, y + h);
  }
  ctx.fill();
  // blinking warning light
  if (Math.floor(globalTick / 20) % 2 === 0) {
    ctx.fillStyle = '#ff5544';
    ctx.beginPath();
    ctx.arc(x + w / 2, y + h - 6, 3, 0, Math.PI * 2);
    ctx.fill();
  }
  ctx.restore();
}

const ROCK_W = 44, ROCK_H = 30;   // grounded rubble: big enough to read at speed 13
function debrisBox(d) {
  if (d.state === 'fall') return { x: d.x - 14, y: d.y - 14, w: 28, h: 28 };
  if (d.state === 'ground') return { x: d.x - ROCK_W / 2, y: GROUND_Y - ROCK_H, w: ROCK_W, h: ROCK_H };
  return null;
}

function drawDebris(d) {
  ctx.save();
  if (d.state === 'fall' || d.state === 'launch') {
    ctx.fillStyle = d.state === 'launch' ? '#8fb6d6' : '#6e6e78';
    ctx.translate(d.x, d.y);
    ctx.rotate(d.t * 0.15);
    ctx.beginPath();
    ctx.moveTo(-14, -5); ctx.lineTo(-5, -14); ctx.lineTo(10, -10);
    ctx.lineTo(14, 5); ctx.lineTo(4, 14); ctx.lineTo(-10, 9);
    ctx.closePath(); ctx.fill();
    ctx.strokeStyle = 'rgba(255,255,255,0.5)';
    ctx.lineWidth = 1.5;
    ctx.stroke();
    ctx.fillStyle = '#8a8a94';
    ctx.fillRect(-5, -7, 7, 6);
    ctx.restore();
    return;
  }

  // Grounded rubble: it's AMMO, so it should look like a target, not scenery.
  const fade = d.t > 60 ? 1 - (d.t - 60) / 30 : 1;
  const p = 0.5 + 0.5 * Math.sin(globalTick * 0.14);
  ctx.globalAlpha = Math.max(0, fade);

  // amber ground glow so it separates from the asphalt at speed
  ctx.shadowColor = 'rgba(255,190,70,' + (0.55 + 0.45 * p).toFixed(3) + ')';
  ctx.shadowBlur = 12 + 8 * p;
  ctx.fillStyle = '#7c7c88';
  ctx.beginPath();
  ctx.moveTo(d.x - 22, GROUND_Y);
  ctx.lineTo(d.x - 15, GROUND_Y - 20);
  ctx.lineTo(d.x - 3, GROUND_Y - 30);
  ctx.lineTo(d.x + 12, GROUND_Y - 24);
  ctx.lineTo(d.x + 20, GROUND_Y - 11);
  ctx.lineTo(d.x + 22, GROUND_Y);
  ctx.closePath();
  ctx.fill();
  ctx.shadowBlur = 0;

  // rim light + facets so the silhouette reads against a dark road
  ctx.strokeStyle = 'rgba(255,225,160,0.9)';
  ctx.lineWidth = 2;
  ctx.stroke();
  ctx.fillStyle = '#9a9aa6';
  ctx.beginPath();
  ctx.moveTo(d.x - 12, GROUND_Y - 6);
  ctx.lineTo(d.x - 6, GROUND_Y - 20);
  ctx.lineTo(d.x + 4, GROUND_Y - 14);
  ctx.closePath();
  ctx.fill();

  // "DASH ME" chevrons bobbing above it
  if (fade > 0.4) {
    const bob = Math.sin(globalTick * 0.15) * 2;
    ctx.strokeStyle = 'rgba(120,200,255,' + (0.55 + 0.45 * p).toFixed(3) + ')';
    ctx.lineWidth = 2.5;
    ctx.beginPath();
    for (let i = 0; i < 2; i++) {
      const cx = d.x - 6 + i * 9;
      ctx.moveTo(cx - 4, GROUND_Y - 40 + bob - i);
      ctx.lineTo(cx + 1, GROUND_Y - 35 + bob - i);
      ctx.lineTo(cx - 4, GROUND_Y - 30 + bob - i);
    }
    ctx.stroke();
  }
  ctx.restore();
}

/* ---------------- Pattern spawner ----------------
   Obstacles arrive in hand-authored chunks with a minimum TIME gap
   between them (scaled by current speed), so the layout is always
   fair at any velocity - no more random unwinnable dice rolls.
   t: p pillar / h hot pillar / s square / hs hot square /
      b barrier / c coin / a coin arc                      */
const CHUNKS = [
  { id: 'breather',   tier: 0, w: 5, span: 0,   ents: [] },
  { id: 'single_p',   tier: 0, w: 10, span: 20, ents: [{ t: 'p', dx: 0 }] },
  { id: 'single_s',   tier: 0, w: 6, span: 20,  ents: [{ t: 's', dx: 0 }] },
  { id: 'single_b',   tier: 0, w: 7, span: 30,  ents: [{ t: 'b', dx: 0 }] },
  { id: 'coin_arc',   tier: 0, w: 8, span: 200, ents: [{ t: 'a', dx: 0 }] },
  { id: 'coin_run',   tier: 0, w: 5, span: 150,
    ents: [{ t: 'c', dx: 0 }, { t: 'c', dx: 50 }, { t: 'c', dx: 100 }, { t: 'c', dx: 150 }] },
  { id: 'double_p',   tier: 1, w: 7, span: 130, ents: [{ t: 'p', dx: 0 }, { t: 'p', dx: 130 }] },
  { id: 'p_arc',      tier: 1, w: 6, span: 240, ents: [{ t: 'a', dx: 0 }, { t: 'p', dx: 88 }] },
  { id: 'single_h',   tier: 1, w: 5, span: 20,  ents: [{ t: 'h', dx: 0 }] },
  { id: 'p_then_s',   tier: 1, w: 6, span: 190, ents: [{ t: 'p', dx: 0 }, { t: 's', dx: 170, dy: -80 }] },
  { id: 'jump_slide', tier: 1, w: 6, span: 200, ents: [{ t: 'p', dx: 0 }, { t: 'b', dx: 200 }] },
  { id: 'slide_jump', tier: 1, w: 5, span: 200, ents: [{ t: 'b', dx: 0 }, { t: 'p', dx: 200 }] },
  { id: 'triple_p',   tier: 2, w: 5, span: 240, ents: [{ t: 'p', dx: 0 }, { t: 'p', dx: 120 }, { t: 'p', dx: 240 }] },
  { id: 'h_double',   tier: 2, w: 4, span: 140, ents: [{ t: 'h', dx: 0 }, { t: 'h', dx: 140 }] },
  { id: 'gauntlet',   tier: 2, w: 4, span: 260, ents: [{ t: 'p', dx: 0 }, { t: 's', dx: 130, dy: -80 }, { t: 'p', dx: 260 }] },
  { id: 'squeeze_b',  tier: 2, w: 4, span: 180, ents: [{ t: 'b', dx: 0 }, { t: 'b', dx: 180 }] },
  { id: 'sky_mines',  tier: 2, w: 4, span: 160,
    ents: [{ t: 's', dx: 0, dy: -70 }, { t: 's', dx: 80, dy: -105 }, { t: 's', dx: 160, dy: -70 }] },
  { id: 'hot_slide',  tier: 3, w: 4, span: 210, ents: [{ t: 'h', dx: 0 }, { t: 'b', dx: 210 }] },
  { id: 'hs_pair',    tier: 3, w: 3, span: 120, ents: [{ t: 'hs', dx: 0, dy: -80 }, { t: 'p', dx: 120 }] },
  { id: 'the_works',  tier: 4, w: 3, span: 340, ents: [{ t: 'p', dx: 0 }, { t: 'b', dx: 170 }, { t: 'h', dx: 340 }] }
];
// stage flavor: chunk-id -> weight multiplier, keyed by stage index
const STAGE_FLAVOR = [
  {},                                          // downtown: baseline
  { single_s: 2, sky_mines: 2, p_then_s: 1.5 },// neon row: sky mines
  { coin_arc: 2, coin_run: 2, p_arc: 1.5 },    // sunrise: coin rush
  { single_b: 2, squeeze_b: 1.6, hot_slide: 1.6, slide_jump: 1.4 } // storm: slide city
];

function pickChunk() {
  const tier = tierFor(score);
  const stage = stageIdxFor(score);
  const flavor = STAGE_FLAVOR[stage] || {};
  const pool = CHUNKS.filter(c => c.tier <= tier);
  let total = 0;
  pool.forEach(c => { total += c.w * (flavor[c.id] || 1); });
  let roll = rng() * total;
  for (const c of pool) {
    roll -= c.w * (flavor[c.id] || 1);
    if (roll <= 0) return c;
  }
  return pool[pool.length - 1];
}

function spawnChunk(chunk) {
  const X = 810;
  const ph = () => Math.floor(rng() * 60);
  chunk.ents.forEach(e => {
    if (e.t === 'p') obstacles.push({ x: X + e.dx, y: GROUND_Y - 30, height: 30, phase: ph() });
    else if (e.t === 'h') hotObstacles.push({ x: X + e.dx, y: GROUND_Y - 30, height: 30, phase: ph() });
    else if (e.t === 's') flyingObstacles.push({ x: X + e.dx, y: GROUND_Y + (e.dy || -80), width: 20, height: 20, phase: ph() });
    else if (e.t === 'hs') hotFlyingObstacles.push({ x: X + e.dx, y: GROUND_Y + (e.dy || -80), width: 20, height: 20, phase: ph() });
    else if (e.t === 'b') barriers.push({ x: X + e.dx, y: GROUND_Y - 138, width: 26, height: 110, phase: ph() });
    else if (e.t === 'c') coins.push(makeCoin(X + e.dx, GROUND_Y - 32));
    else if (e.t === 'a') {
      const H = [10, 60, 95, 60, 10]; // traces a jump arc
      for (let i = 0; i < 5; i++) coins.push(makeCoin(X + e.dx + i * 45, GROUND_Y - 22 - H[i]));
    }
  });
}

function updateSpawner(es) {
  if (boss.active) return; // the kaiju owns the road during a boss
  spawnDist -= es;
  if (spawnDist > 0) return;
  const chunk = pickChunk();
  spawnChunk(chunk);
  const tier = tierFor(score);
  const gapTicks = Math.max(24, 40 - tier * 3) + rng() * 26;
  spawnDist = chunk.span + 40 + gapTicks * speed;
}

/* ---------------- Pickup spawning / collection ---------------- */
/* Pickups come from a shuffled BAG, not independent dice. Every bag
   holds one of each rare power-up plus a few staples, so you can't go a
   whole run without seeing rampage - and can't get four shields in a row.
   Same fairness fix the obstacle spawner got. */
const PICKUP_BAG = [
  'doublejump', 'doublejump', 'doublejump',
  'heart', 'heart',
  'invis', 'invis',
  'shield', 'shield',
  'magnet', 'x2', 'slowmo', 'rampage'
];
let pickupBag = [];
const SLOWMO_UNLOCK = 4000;   // slow-mo simply does not exist before this
function refillBag() {
  pickupBag = PICKUP_BAG.slice();
  for (let i = pickupBag.length - 1; i > 0; i--) {   // Fisher-Yates on rng
    const j = Math.floor(rng() * (i + 1));
    const t = pickupBag[i]; pickupBag[i] = pickupBag[j]; pickupBag[j] = t;
  }
}
function rollPickupKind() {
  // Hard gate: slow-mo is disorienting before the world is fast enough to
  // need it. Below the unlock the token is DISCARDED from the bag entirely
  // (never returned to it - that would starve the bag and jam the draw).
  for (let guard = 0; guard < 40; guard++) {
    if (!pickupBag.length) refillBag();
    const kind = pickupBag.pop();
    if (kind === 'slowmo' && score < SLOWMO_UNLOCK) continue;
    return kind;
  }
  return 'doublejump';
}

function overflowBonus(pu) {
  sfx('arp');
  const g = bonus(100);
  score += g;
  addPopup(pu.x, pu.y, '+' + g);
}

/* Bob/spin/glow run on a PRIVATE clock with a random phase, never on world
   position. Reading the phase off `x` coupled the animation to scroll speed:
   at speed 13 the bob was advancing ~13 radians per tick - about 125 cycles a
   second - which aliases into garbage on a 60fps display and looked like the
   pickups were speeding up with the game. */
function makePickup(kind, x, y) {
  return { kind: kind, x: x, y: y, width: 20, height: 20,
           ph: rng() * Math.PI * 2, bobT: Math.floor(rng() * 120) };
}
function makeCoin(x, y) {
  return { x: x, y: y, r: 8, ph: rng() * Math.PI * 2, bobT: Math.floor(rng() * 120) };
}

const PICKUP_NAME = {
  doublejump: 'DOUBLE JUMP', heart: 'HEALTH', shield: 'SHIELD',
  invis: 'INVISIBILITY', magnet: 'MAGNET', x2: 'SCORE x2',
  slowmo: 'SLOW-MO', rampage: 'RAMPAGE'
};

function collectPickup(pu) {
  const cx = pu.x + pu.width / 2;
  if (PICKUP_NAME[pu.kind]) addPopup(cx, pu.y - 6, PICKUP_NAME[pu.kind], true);
  switch (pu.kind) {
    case 'doublejump':
      if (doubleJumpCount >= 3) overflowBonus(pu); else doubleJumpCount++;
      break;
    case 'heart':
      if (health >= maxHealth) overflowBonus(pu); else health++;
      break;
    case 'shield':
      // grabbing a shield you already have just tops the timer back up
      if (shieldCharges >= 1 && shieldTimer > SHIELD_DUR * 0.6) overflowBonus(pu);
      shieldCharges = 1;
      shieldTimer = SHIELD_DUR;
      break;
    case 'invis': timers.invis = 300; break;
    case 'magnet':  timers.magnet = 700; break;
    case 'x2':      timers.x2 = 600; break;
    case 'slowmo':  timers.slowmo = 240; break;
    case 'rampage':
      timers.rampage = 300;
      setBanner('RAMPAGE!', 'Smash everything');
      break;
  }
  sfx(pu.kind === 'rampage' ? 'rampage' : 'pickup');
  playOneShot('collect');
}

/* ---------------- Boss: kaiju road fight ----------------
   The kaiju stomps rocks onto the road. Jumping them is survival;
   DASHING them launches the rock back into its face. Six hits and
   it goes down. Between stomps it mixes in a tail sweep (jump), a
   plasma bolt (jump or slide) and a ground shockwave (jump only). */
const BOSS_LEN = 2400;        // it retreats if you can't finish it
const ATK_EVERY = 165;
const BOSS_SEQ = ['stomp', 'sweep', 'stomp', 'plasma', 'stomp', 'wave'];

/* Spiking a rock refunds the dash instantly and re-arms the air dash.
   Clearing one rock must never be the reason the next one kills you -
   good play should CHAIN, not cost you your only tool. */
function launchRock(d) {
  sfx('zip');
  d.state = 'launch';
  d.vx = 11;
  d.vy = -7.5;
  d.t = 0;
  streak++;
  dashCd = 0;
  airDashUsed = false;
  dashTimer = Math.max(dashTimer, 6);   // ride the lunge into the next rock
  const g = bonus(30);
  score += g;
  addPopup(d.x, d.y - 10, '+' + g + ' RETURN!', true);
}

function bossHit() {
  sfx('bossHit');
  boss.hp--;
  boss.flinch = 22;
  shake = Math.max(shake, 12);
  addPopup(BOSS_X - 40, 120, 'HIT!');
  if (boss.hp <= 0) killBoss();
}

/* The next kaiju is scheduled off the score AFTER the reward is paid.
   A 1500 base kill at x3 combo with x2 running is 9000 points - enough to
   leapfrog a fixed "+5000" threshold and resurrect the thing instantly. */
function endBoss() {
  boss.active = false;
  hazards = [];
  telegraphs = [];
  debris = debris.filter(d => d.state === 'ground');
}
function scheduleNextBoss() {
  boss.next = bossesOn ? score + 5000 : Infinity;
}

function killBoss() {
  if (!boss.active) return;      // guard: two rocks can land on the same tick
  endBoss();
  sfx('fanfare');
  const g = bonus(1500);
  score += g;
  scheduleNextBoss();            // ...only now is the score final
  shake = 16;
  setBanner('KAIJU DOWN', '+' + g);
  pickups.push(makePickup('heart', 700, GROUND_Y - 60));
}

function bossAttack(kind) {
  if (kind === 'stomp') {
    // cluster them within one dash-chain's reach of each other
    const n = 2 + Math.floor(rng() * 2);
    let x = 130 + rng() * 180;
    for (let i = 0; i < n; i++) {
      telegraphs.push({ x: Math.min(700, x), t: -i * 16 });
      x += 120 + rng() * 70;   // 120-190px apart: chainable, never overlapping
    }
  } else if (kind === 'sweep') {
    hazards.push({ type: 'sweep', x: 820, warn: 40, dmg: 1 });
  } else if (kind === 'plasma') {
    hazards.push({ type: 'plasma', x: 820, y: GROUND_Y - 140, warn: 35, dmg: 2 });
  } else if (kind === 'wave') {
    hazards.push({ type: 'wave', x: 820, warn: 40, dmg: 1 });
  }
}

function hazardBox(hz) {
  if (hz.type === 'sweep') return { x: hz.x, y: GROUND_Y - 34, w: 90, h: 34 };
  if (hz.type === 'plasma') return { x: hz.x, y: hz.y, w: 34, h: 116 };
  return { x: hz.x, y: GROUND_Y - 22, w: 30, h: 22 };   // wave
}

function updateHazards() {
  hazards.forEach(hz => {
    if (hz.warn > 0) { hz.warn--; return; }
    hz.x -= hz.type === 'wave' ? 10 : (hz.type === 'plasma' ? 8.5 : 7);
  });
  hazards = hazards.filter(hz => !hz.dead && hz.x > -120);
}

function updateBoss() {
  if (!bossesOn && !boss.active) return;
  if (!boss.active && score >= boss.next) {
    boss.active = true;
    boss.t = 0;
    boss.hp = BOSS_HP;
    boss.flinch = 0;
    boss.seq = 0;
    telegraphs = [];
    hazards = [];
    sfx('roar');
    setBanner('!! KAIJU ATTACK !!', 'DASH the rocks back at it');
  }
  if (!boss.active) return;
  boss.t++;
  if (boss.flinch > 0) boss.flinch--;

  if (boss.t % ATK_EVERY === 40 && boss.t < BOSS_LEN - 100) {
    bossAttack(BOSS_SEQ[boss.seq % BOSS_SEQ.length]);
    boss.seq++;
  }

  telegraphs = telegraphs.filter(tg => {
    tg.t++;
    if (tg.t >= 50) {
      debris.push({ x: tg.x, y: -30, vy: 5, vx: 0, state: 'fall', t: 0 });
      return false;
    }
    return true;
  });

  updateHazards();

  if (boss.t >= BOSS_LEN) {
    endBoss();
    const g = bonus(300);
    score += g;
    scheduleNextBoss();
    setBanner('KAIJU RETREATS', '+' + g + ' - dash its rocks next time');
  }
}

function updateDebris(es) {
  debris.forEach(d => {
    d.t++;
    if (d.state === 'launch') {
      d.x += d.vx;
      d.y += d.vy;
      d.vy += 0.22;
      // reached the kaiju's chest?
      if (boss.active && d.x >= BOSS_X - 70 && d.y < GROUND_Y - 60) {
        d.dead = true;
        bossHit();
      } else if (d.y > GROUND_Y || d.x > 860) {
        d.dead = true;
      }
    } else if (d.state === 'fall') {
      d.y += d.vy;
      d.vy += 0.25;
      if (d.y >= GROUND_Y - 20) {
        d.state = 'ground';
        d.t = 0;
        shake = Math.max(shake, 9);
      }
    } else {
      d.x -= es;
    }
  });
  debris = debris.filter(d => !d.dead && !(d.state === 'ground' && d.t > 90) && d.x > -60);
}

function drawBossKaiju() {
  const p = pulse((boss.t % ATK_EVERY) / ATK_EVERY, 0.20, 0.42);
  const bob = Math.sin(globalTick * 0.05) * 3;
  const rec = boss.flinch > 0 ? (boss.flinch / 22) : 0;   // knocked back on a hit
  ctx.save();
  if (rec) {
    ctx.globalAlpha = 0.75 + 0.25 * Math.abs(Math.sin(globalTick * 0.6));
    ctx.translate(rec * 14, -rec * 4);
  }
  drawKaiju(BOSS_X + 20, 0.04 - p * 0.22 + rec * 0.12, Math.max(p, rec), bob, 1.5);
  ctx.restore();

}

/* Boss health: centred along the top, clear of the score readout.
   Drawn with the HUD so obstacles can't cover it. */
function drawBossHealth() {
  if (!boss.active) return;
  const bw = 240, bx = canvas.width / 2 - bw / 2, by = 26;
  const frac = Math.max(0, boss.hp / BOSS_HP);
  ctx.save();
  ctx.fillStyle = 'rgba(0,0,0,0.5)';
  ctx.fillRect(bx - 3, by - 3, bw + 6, 14);
  ctx.fillStyle = '#3a1210';
  ctx.fillRect(bx, by, bw, 8);
  const g = ctx.createLinearGradient(bx, by, bx, by + 8);
  g.addColorStop(0, '#ff6b52');
  g.addColorStop(1, '#a01f14');
  ctx.fillStyle = g;
  ctx.fillRect(bx, by, bw * frac, 8);
  // segment ticks, one per hit point
  ctx.strokeStyle = 'rgba(0,0,0,0.55)';
  ctx.lineWidth = 1;
  for (let i = 1; i < BOSS_HP; i++) {
    const x = bx + (bw * i) / BOSS_HP;
    ctx.beginPath(); ctx.moveTo(x, by); ctx.lineTo(x, by + 8); ctx.stroke();
  }
  ctx.strokeStyle = 'rgba(255,255,255,0.75)';
  ctx.strokeRect(bx, by, bw, 8);
  ctx.font = 'bold 12px Arial';
  ctx.textAlign = 'center';
  ctx.lineWidth = 3;
  ctx.strokeStyle = 'rgba(0,0,0,0.6)';
  ctx.strokeText('KAIJU', canvas.width / 2, by - 6);
  ctx.fillStyle = '#fff';
  ctx.fillText('KAIJU', canvas.width / 2, by - 6);
  ctx.restore();
  ctx.textAlign = 'left';
}

function drawHazards() {
  hazards.forEach(hz => {
    ctx.save();
    if (hz.warn > 0) {
      // telegraph: flashing ghost of what's coming
      const flash = Math.floor(hz.warn / 5) % 2 === 0;
      ctx.globalAlpha = flash ? 0.5 : 0.2;
      ctx.fillStyle = '#ff4433';
      if (hz.type === 'sweep') ctx.fillRect(700, GROUND_Y - 34, 100, 34);
      else if (hz.type === 'plasma') ctx.fillRect(760, hz.y, 40, 116);
      else ctx.fillRect(760, GROUND_Y - 22, 40, 22);
      ctx.globalAlpha = 1;
      ctx.fillStyle = '#ff4433';
      ctx.font = 'bold 15px Arial';
      ctx.textAlign = 'center';
      ctx.fillText(hz.type === 'plasma' ? 'SLIDE' : 'JUMP', 740, hz.type === 'plasma' ? hz.y - 10 : GROUND_Y - 40);
      ctx.restore();
      ctx.textAlign = 'left';
      return;
    }
    if (hz.type === 'sweep') {
      // the kaiju's tail whipping down the road
      const g = ctx.createLinearGradient(hz.x, 0, hz.x + 90, 0);
      g.addColorStop(0, sCol('kaiju'));
      g.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = sCol('kaiju');
      ctx.beginPath();
      ctx.moveTo(hz.x, GROUND_Y);
      ctx.lineTo(hz.x + 6, GROUND_Y - 34);
      ctx.lineTo(hz.x + 70, GROUND_Y - 22);
      ctx.lineTo(hz.x + 90, GROUND_Y);
      ctx.closePath();
      ctx.fill();
      ctx.fillStyle = 'rgba(255,255,255,0.25)';
      ctx.fillRect(hz.x + 10, GROUND_Y - 26, 46, 3);
    } else if (hz.type === 'plasma') {
      const cx = hz.x + 17, cy = hz.y + 58;
      ctx.shadowColor = 'rgba(255,140,60,0.9)';
      ctx.shadowBlur = 18;
      const g = ctx.createLinearGradient(cx, cy - 58, cx, cy + 58);
      g.addColorStop(0, '#ffe28a');
      g.addColorStop(1, '#ff5a2a');
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.ellipse(cx, cy, 17, 58, 0, 0, Math.PI * 2);
      ctx.fill();
      ctx.shadowBlur = 0;
      ctx.fillStyle = 'rgba(255,255,255,0.6)';
      ctx.beginPath();
      ctx.ellipse(cx + 4, cy - 14, 5, 18, 0, 0, Math.PI * 2);
      ctx.fill();
    } else {
      // shockwave ripple hugging the asphalt
      ctx.strokeStyle = 'rgba(255,210,62,0.9)';
      ctx.lineWidth = 3;
      for (let i = 0; i < 3; i++) {
        ctx.beginPath();
        ctx.ellipse(hz.x + 15 + i * 10, GROUND_Y - 2, 14 - i * 3, 22 - i * 5, 0, Math.PI * 1.05, Math.PI * 1.95);
        ctx.stroke();
      }
      ctx.fillStyle = 'rgba(255,210,62,0.35)';
      ctx.fillRect(hz.x, GROUND_Y - 22, 30, 22);
    }
    ctx.restore();
  });
}

function drawDebrisLaunchTrail(d) {
  if (d.state !== 'launch') return;
  ctx.save();
  ctx.strokeStyle = 'rgba(120,200,255,0.5)';
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.moveTo(d.x - d.vx * 2, d.y - d.vy * 2);
  ctx.lineTo(d.x - d.vx * 5, d.y - d.vy * 5);
  ctx.stroke();
  ctx.restore();
}

function drawTelegraphs() {
  telegraphs.forEach(tg => {
    if (tg.t < 0) return;
    const flash = Math.floor(tg.t / 6) % 2 === 0;
    ctx.save();
    ctx.globalAlpha = 0.35 + 0.4 * (tg.t / 50);
    ctx.strokeStyle = flash ? '#ff4433' : '#ffb199';
    ctx.lineWidth = 3;
    ctx.beginPath();
    ctx.ellipse(tg.x, GROUND_Y + 8, 26, 7, 0, 0, Math.PI * 2);
    ctx.stroke();
    ctx.fillStyle = flash ? '#ff4433' : '#ffb199';
    ctx.font = 'bold 20px Arial';
    ctx.textAlign = 'center';
    ctx.fillText('!', tg.x, GROUND_Y - 14 - (tg.t % 12));
    ctx.restore();
    ctx.textAlign = 'left';
  });
}

/* ---------------- Main loop ---------------- */
/* Slow-mo eases in and, more importantly, eases OUT - the world
   spools back up to full speed over ~1.5s instead of snapping and
   throwing you into a pillar you'd already mentally cleared. */
const SLOW_FACTOR = 0.55;
let slowF = 1;
function effSpeed() { return speed * slowF; }

function updateGame() {
  const es = effSpeed();

  // physics
  dino.y += dino.vy;
  dino.vy += 0.6;
  if (dino.y + curH() >= GROUND_Y) {
    dino.y = GROUND_Y - curH();
    dino.vy = 0;
    dino.jumping = false;
    dino.jumpsUsed = 0;
    dino.usedDouble = false;
    airDashUsed = false;
    canJump = true;
  }

  // dash lifecycle: lunge forward, then drift back to the lane mark
  if (dashTimer > 0) {
    dashTimer--;
    dino.x = Math.min(DINO_X0 + 62, dino.x + DASH_PUSH);
  } else if (dino.x > DINO_X0) {
    dino.x = Math.max(DINO_X0, dino.x - 2.4);
  }
  if (dashCd > 0 && !dashing()) dashCd--;

  // slide lifecycle
  if (sliding) {
    slideTimer--;
    if (slideTimer <= 0) endSlide();
  } else {
    if (slideCd > 0) slideCd--;
    if (downHeld && grounded() && slideCd <= 0) startSlide();
  }

  // slow-mo blend: snap in quick, spool back out gently
  const slowTarget = timers.slowmo > 0 ? SLOW_FACTOR : 1;
  const rate = timers.slowmo > 0 ? 0.10 : 0.022;
  slowF += (slowTarget - slowF) * rate;
  if (Math.abs(slowF - slowTarget) < 0.004) slowF = slowTarget;

  // effect timers
  Object.keys(timers).forEach(k => { if (timers[k] > 0) timers[k]--; });
  if (shieldCharges > 0) {
    shieldTimer--;
    if (shieldTimer <= 0) {
      shieldCharges = 0;
      addPopup(dino.x + DINO_W / 2, dino.y - 12, 'SHIELD OUT', true);
    }
  }
  updateInvincibility();
  checkCollisions();

  updateBoss();
  if (!boss.active && hazards.length) updateHazards();  // let stragglers fly off
  updateSpawner(es);
  updateDebris(es);

  // rare roaming pickups
  if (!boss.active && rng() < 0.011) {
    pickups.push(makePickup(rollPickupKind(), 810, GROUND_Y - 60));
  }

  // movement
  const advanceObstacle = (ob) => {
    ob.x -= es;
    if (ob.breaking) ob.breakTick++;
  };
  obstacles.forEach(advanceObstacle);
  hotObstacles.forEach(advanceObstacle);
  flyingObstacles.forEach(fo => { fo.x -= es; });
  hotFlyingObstacles.forEach(fo => { fo.x -= es; });
  barriers.forEach(b => { b.x -= es; });
  // world position scrolls with the road; the bob clock does not
  coins.forEach(c => { c.x -= es; c.bobT++; });
  pickups.forEach(pu => { pu.x -= es; pu.bobT++; });

  // magnet pull
  if (timers.magnet > 0) {
    const px = dino.x + DINO_W / 2, py = dino.y + curH() / 2;
    const pull = (o, cx, cy) => {
      const dx = px - cx, dy = py - cy;
      const dist = Math.sqrt(dx * dx + dy * dy);
      if (dist < 140 && dist > 4) {
        o.x += (dx / dist) * 4.5;
        o.y += (dy / dist) * 4.5;
      }
    };
    coins.forEach(c => pull(c, c.x, c.y));
    pickups.forEach(pu => pull(pu, pu.x + pu.width / 2, pu.y + pu.height / 2));
  }

  // collect coins
  coins = coins.filter(c => {
    if (hitTest(c.x - c.r, c.y - c.r, c.r * 2, c.r * 2)) {
      streak++;
      sfx('coin');
      const g = bonus(10);
      score += g;
      addPopup(c.x, c.y - 6, '+' + g, true);
      return false;
    }
    return c.x > -20;
  });

  // collect pickups
  pickups = pickups.filter(pu => {
    if (hitTest(pu.x, pu.y, pu.width, pu.height)) {
      collectPickup(pu);
      return false;
    }
    return pu.x > -pu.width;
  });

  // popups drift + fade
  popups.forEach(p => { p.t++; p.x -= es * 0.4; p.y -= 0.8; });
  popups = popups.filter(p => p.t < 50);

  // cull
  const BREAK_TOTAL =
    (OB_SHEET.pillar_black.n - OB_SHEET.pillar_black.idle) * OB_BREAK_TICKS +
    OB_BREAK_LINGER;
  const keepPillar = (ob) =>
    ob.x > -80 && (!ob.breaking || ob.breakTick < BREAK_TOTAL);
  obstacles = obstacles.filter(keepPillar);
  hotObstacles = hotObstacles.filter(keepPillar);
  flyingObstacles = flyingObstacles.filter(fo => !fo.dead && fo.x > -80);
  hotFlyingObstacles = hotFlyingObstacles.filter(fo => !fo.dead && fo.x > -80);
  barriers = barriers.filter(b => !b.dead && b.x > -80);

  // score + difficulty (derived from score: bonus points advance the curve)
  score += timers.x2 > 0 ? 2 : 1;
  speed = Math.min(13, baseSpeed + Math.floor(score / 550) * 0.5);

  // stage transitions
  const target = stageIdxFor(score);
  if (target !== stTo) {
    stFrom = stTo;
    stTo = target;
    stT = 0;
    const stageNum = Math.floor(score / STAGE_LEN) + 1;
    sfx('stage');
    setBanner('STAGE ' + stageNum + ' - ' + STAGES[target].name, STAGES[target].sub);
  }
  if (stT < 1) stT = Math.min(1, stT + 0.012);

  if (shake > 0) shake--;

  advanceAnim();
}

function drawGame() {
  ctx.save();
  if (shake > 0) {
    ctx.translate((Math.random() - 0.5) * shake, (Math.random() - 0.5) * shake * 0.6);
  }

  drawBackground();
  drawTelegraphs();

  // world behind Waltor
  obstacles.forEach(ob => { if (!ob.breaking) drawPillar(ob, false); });
  hotObstacles.forEach(hot => { if (!hot.breaking) drawPillar(hot, true); });
  flyingObstacles.forEach(fo => drawSquare(fo, false));
  hotFlyingObstacles.forEach(fo => drawSquare(fo, true));
  barriers.forEach(b => { if (!b.dead) drawBarrier(b); });
  drawHazards();
  debris.forEach(d => { drawDebrisLaunchTrail(d); drawDebris(d); });
  coins.forEach(c => drawCoin(c));
  pickups.forEach(pu => drawPickup(pu));

  drawWaltor();

  // crumbling pillars in front - Waltor smashes THROUGH them
  obstacles.forEach(ob => { if (ob.breaking) drawPillar(ob, false); });
  hotObstacles.forEach(hot => { if (hot.breaking) drawPillar(hot, true); });

  // (invisibility now shows as a chip + drain bar under the hearts, via
  // drawEffectsHUD, exactly like every other timed power-up)

  // popups
  popups.forEach(p => {
    const fade = p.t < 35 ? 1 : 1 - (p.t - 35) / 15;
    ctx.save();
    ctx.globalAlpha = Math.max(0, fade);
    ctx.font = 'bold ' + (p.small ? 13 : 16) + 'px Arial';
    ctx.textAlign = 'center';
    ctx.lineWidth = 3;
    ctx.strokeStyle = 'rgba(0,0,0,0.55)';
    ctx.strokeText(p.text, p.x, p.y);
    ctx.fillStyle = '#ffd23e';
    ctx.fillText(p.text, p.x, p.y);
    ctx.restore();
  });
  ctx.textAlign = 'left';

  drawHearts();
  drawEffectsHUD();
  drawScore();
  drawBossHealth();
  drawBanner();

  ctx.restore();
}

function drawMenuScene() {
  drawBackground();
  const m = SHEET.idle;
  const frame = Math.floor(globalTick / FRAME_TICKS) % m.n;
  const dw = m.cw * SCALE, dh = m.ch * SCALE;
  if (spriteReady) {
    ctx.imageSmoothingEnabled = false;
    ctx.drawImage(sprite, frame * m.cw, m.y, m.cw, m.ch,
      dino.x + DINO_W / 2 - dw / 2, GROUND_Y - dh, dw, dh);
  }
}

// Frozen death frame: the world holds, the killer finishes crumbling.
function drawGameOverScene() {
  const adv = ob => { if (ob.breaking) ob.breakTick++; };
  obstacles.forEach(adv);
  hotObstacles.forEach(adv);
  drawGame();
}

function frame() {
  if (paused && running) {
    if (!pauseDrawn) { drawPauseOverlay(); pauseDrawn = true; }
    animationFrameId = requestAnimationFrame(frame);
    return;
  }
  globalTick++;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  if (running) {
    updateGame();
    if (running) drawGame();
    else drawGameOverScene();
  } else if (started) {
    drawGameOverScene();
  } else {
    drawMenuScene();
  }
  animationFrameId = requestAnimationFrame(frame);
}

frame();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
